// source: protocol_signaling.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var header_entity_pb = require('./header_entity_pb.js');
goog.object.extend(proto, header_entity_pb);
var signaling_param_pb = require('./signaling_param_pb.js');
goog.object.extend(proto, signaling_param_pb);
goog.exportSymbol('proto.himpb.SigMemberStatus', null, global);
goog.exportSymbol('proto.himpb.SignalingCloseReq', null, global);
goog.exportSymbol('proto.himpb.SignalingCloseRsp', null, global);
goog.exportSymbol('proto.himpb.SignalingCreateReq', null, global);
goog.exportSymbol('proto.himpb.SignalingCreateRsp', null, global);
goog.exportSymbol('proto.himpb.SignalingInviteOfflineRelayNty', null, global);
goog.exportSymbol('proto.himpb.SignalingInviteRelayNty', null, global);
goog.exportSymbol('proto.himpb.SignalingInviteReq', null, global);
goog.exportSymbol('proto.himpb.SignalingInviteResultRcp', null, global);
goog.exportSymbol('proto.himpb.SignalingInviteRsp', null, global);
goog.exportSymbol('proto.himpb.SignalingJoinReq', null, global);
goog.exportSymbol('proto.himpb.SignalingJoinRsp', null, global);
goog.exportSymbol('proto.himpb.SignalingKeepLiveNty', null, global);
goog.exportSymbol('proto.himpb.SignalingKeepLiveReq', null, global);
goog.exportSymbol('proto.himpb.SignalingKeepLiveRsp', null, global);
goog.exportSymbol('proto.himpb.SignalingMemberStatusChangedBatchNty', null, global);
goog.exportSymbol('proto.himpb.SignalingMemberStatusChangedNty', null, global);
goog.exportSymbol('proto.himpb.SignalingQueryReq', null, global);
goog.exportSymbol('proto.himpb.SignalingQueryRsp', null, global);
goog.exportSymbol('proto.himpb.SignalingSessionStatusChangedNty', null, global);
goog.exportSymbol('proto.himpb.SignalingUserCtrlNty', null, global);
goog.exportSymbol('proto.himpb.SignalingUserCtrlRcp', null, global);
goog.exportSymbol('proto.himpb.SignalingUserJoinedNty', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.himpb.SignalingCreateReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.himpb.SignalingCreateReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.himpb.SignalingCreateReq.displayName = 'proto.himpb.SignalingCreateReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.himpb.SignalingCreateRsp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.himpb.SignalingCreateRsp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.himpb.SignalingCreateRsp.displayName = 'proto.himpb.SignalingCreateRsp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.himpb.SignalingCloseReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.himpb.SignalingCloseReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.himpb.SignalingCloseReq.displayName = 'proto.himpb.SignalingCloseReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.himpb.SignalingCloseRsp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.himpb.SignalingCloseRsp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.himpb.SignalingCloseRsp.displayName = 'proto.himpb.SignalingCloseRsp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.himpb.SignalingInviteReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.himpb.SignalingInviteReq.repeatedFields_, null);
};
goog.inherits(proto.himpb.SignalingInviteReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.himpb.SignalingInviteReq.displayName = 'proto.himpb.SignalingInviteReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.himpb.SignalingInviteRsp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.himpb.SignalingInviteRsp.repeatedFields_, null);
};
goog.inherits(proto.himpb.SignalingInviteRsp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.himpb.SignalingInviteRsp.displayName = 'proto.himpb.SignalingInviteRsp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.himpb.SignalingInviteRelayNty = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.himpb.SignalingInviteRelayNty.repeatedFields_, null);
};
goog.inherits(proto.himpb.SignalingInviteRelayNty, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.himpb.SignalingInviteRelayNty.displayName = 'proto.himpb.SignalingInviteRelayNty';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.himpb.SignalingUserJoinedNty = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.himpb.SignalingUserJoinedNty.repeatedFields_, null);
};
goog.inherits(proto.himpb.SignalingUserJoinedNty, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.himpb.SignalingUserJoinedNty.displayName = 'proto.himpb.SignalingUserJoinedNty';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.himpb.SignalingInviteOfflineRelayNty = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.himpb.SignalingInviteOfflineRelayNty.repeatedFields_, null);
};
goog.inherits(proto.himpb.SignalingInviteOfflineRelayNty, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.himpb.SignalingInviteOfflineRelayNty.displayName = 'proto.himpb.SignalingInviteOfflineRelayNty';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.himpb.SignalingInviteResultRcp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.himpb.SignalingInviteResultRcp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.himpb.SignalingInviteResultRcp.displayName = 'proto.himpb.SignalingInviteResultRcp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.himpb.SignalingJoinReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.himpb.SignalingJoinReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.himpb.SignalingJoinReq.displayName = 'proto.himpb.SignalingJoinReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.himpb.SignalingJoinRsp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.himpb.SignalingJoinRsp.repeatedFields_, null);
};
goog.inherits(proto.himpb.SignalingJoinRsp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.himpb.SignalingJoinRsp.displayName = 'proto.himpb.SignalingJoinRsp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.himpb.SignalingKeepLiveReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.himpb.SignalingKeepLiveReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.himpb.SignalingKeepLiveReq.displayName = 'proto.himpb.SignalingKeepLiveReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.himpb.SignalingKeepLiveRsp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.himpb.SignalingKeepLiveRsp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.himpb.SignalingKeepLiveRsp.displayName = 'proto.himpb.SignalingKeepLiveRsp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.himpb.SignalingKeepLiveNty = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.himpb.SignalingKeepLiveNty, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.himpb.SignalingKeepLiveNty.displayName = 'proto.himpb.SignalingKeepLiveNty';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.himpb.SignalingUserCtrlNty = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.himpb.SignalingUserCtrlNty, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.himpb.SignalingUserCtrlNty.displayName = 'proto.himpb.SignalingUserCtrlNty';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.himpb.SignalingUserCtrlRcp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.himpb.SignalingUserCtrlRcp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.himpb.SignalingUserCtrlRcp.displayName = 'proto.himpb.SignalingUserCtrlRcp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.himpb.SignalingSessionStatusChangedNty = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.himpb.SignalingSessionStatusChangedNty.repeatedFields_, null);
};
goog.inherits(proto.himpb.SignalingSessionStatusChangedNty, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.himpb.SignalingSessionStatusChangedNty.displayName = 'proto.himpb.SignalingSessionStatusChangedNty';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.himpb.SignalingMemberStatusChangedNty = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.himpb.SignalingMemberStatusChangedNty.repeatedFields_, null);
};
goog.inherits(proto.himpb.SignalingMemberStatusChangedNty, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.himpb.SignalingMemberStatusChangedNty.displayName = 'proto.himpb.SignalingMemberStatusChangedNty';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.himpb.SignalingMemberStatusChangedBatchNty = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.himpb.SignalingMemberStatusChangedBatchNty.repeatedFields_, null);
};
goog.inherits(proto.himpb.SignalingMemberStatusChangedBatchNty, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.himpb.SignalingMemberStatusChangedBatchNty.displayName = 'proto.himpb.SignalingMemberStatusChangedBatchNty';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.himpb.SigMemberStatus = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.himpb.SigMemberStatus.repeatedFields_, null);
};
goog.inherits(proto.himpb.SigMemberStatus, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.himpb.SigMemberStatus.displayName = 'proto.himpb.SigMemberStatus';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.himpb.SignalingQueryReq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.himpb.SignalingQueryReq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.himpb.SignalingQueryReq.displayName = 'proto.himpb.SignalingQueryReq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.himpb.SignalingQueryRsp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.himpb.SignalingQueryRsp.repeatedFields_, null);
};
goog.inherits(proto.himpb.SignalingQueryRsp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.himpb.SignalingQueryRsp.displayName = 'proto.himpb.SignalingQueryRsp';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.himpb.SignalingCreateReq.prototype.toObject = function(opt_includeInstance) {
  return proto.himpb.SignalingCreateReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.himpb.SignalingCreateReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.SignalingCreateReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    base: (f = msg.getBase()) && header_entity_pb.ReqBase.toObject(includeInstance, f),
    type: jspb.Message.getFieldWithDefault(msg, 2, 0),
    roomname: jspb.Message.getFieldWithDefault(msg, 3, ""),
    roomextinfo: jspb.Message.getFieldWithDefault(msg, 4, ""),
    creatorname: jspb.Message.getFieldWithDefault(msg, 5, ""),
    source: jspb.Message.getFieldWithDefault(msg, 6, 0),
    srcid: jspb.Message.getFieldWithDefault(msg, 7, ""),
    custominfo: jspb.Message.getFieldWithDefault(msg, 8, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.himpb.SignalingCreateReq}
 */
proto.himpb.SignalingCreateReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.himpb.SignalingCreateReq;
  return proto.himpb.SignalingCreateReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.himpb.SignalingCreateReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.himpb.SignalingCreateReq}
 */
proto.himpb.SignalingCreateReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new header_entity_pb.ReqBase;
      reader.readMessage(value,header_entity_pb.ReqBase.deserializeBinaryFromReader);
      msg.setBase(value);
      break;
    case 2:
      var value = /** @type {!proto.himpb.ESig.SessionType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setRoomname(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setRoomextinfo(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreatorname(value);
      break;
    case 6:
      var value = /** @type {!proto.himpb.ESig.SourceType} */ (reader.readEnum());
      msg.setSource(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setSrcid(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setCustominfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.himpb.SignalingCreateReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.himpb.SignalingCreateReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.himpb.SignalingCreateReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.SignalingCreateReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBase();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      header_entity_pb.ReqBase.serializeBinaryToWriter
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getRoomname();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getRoomextinfo();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getCreatorname();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getSource();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getSrcid();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getCustominfo();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
};


/**
 * optional ReqBase base = 1;
 * @return {?proto.himpb.ReqBase}
 */
proto.himpb.SignalingCreateReq.prototype.getBase = function() {
  return /** @type{?proto.himpb.ReqBase} */ (
    jspb.Message.getWrapperField(this, header_entity_pb.ReqBase, 1));
};


/**
 * @param {?proto.himpb.ReqBase|undefined} value
 * @return {!proto.himpb.SignalingCreateReq} returns this
*/
proto.himpb.SignalingCreateReq.prototype.setBase = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.himpb.SignalingCreateReq} returns this
 */
proto.himpb.SignalingCreateReq.prototype.clearBase = function() {
  return this.setBase(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.himpb.SignalingCreateReq.prototype.hasBase = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional ESig.SessionType type = 2;
 * @return {!proto.himpb.ESig.SessionType}
 */
proto.himpb.SignalingCreateReq.prototype.getType = function() {
  return /** @type {!proto.himpb.ESig.SessionType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.himpb.ESig.SessionType} value
 * @return {!proto.himpb.SignalingCreateReq} returns this
 */
proto.himpb.SignalingCreateReq.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string roomName = 3;
 * @return {string}
 */
proto.himpb.SignalingCreateReq.prototype.getRoomname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.SignalingCreateReq} returns this
 */
proto.himpb.SignalingCreateReq.prototype.setRoomname = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string roomExtInfo = 4;
 * @return {string}
 */
proto.himpb.SignalingCreateReq.prototype.getRoomextinfo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.SignalingCreateReq} returns this
 */
proto.himpb.SignalingCreateReq.prototype.setRoomextinfo = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string creatorName = 5;
 * @return {string}
 */
proto.himpb.SignalingCreateReq.prototype.getCreatorname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.SignalingCreateReq} returns this
 */
proto.himpb.SignalingCreateReq.prototype.setCreatorname = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional ESig.SourceType source = 6;
 * @return {!proto.himpb.ESig.SourceType}
 */
proto.himpb.SignalingCreateReq.prototype.getSource = function() {
  return /** @type {!proto.himpb.ESig.SourceType} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.himpb.ESig.SourceType} value
 * @return {!proto.himpb.SignalingCreateReq} returns this
 */
proto.himpb.SignalingCreateReq.prototype.setSource = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional string srcId = 7;
 * @return {string}
 */
proto.himpb.SignalingCreateReq.prototype.getSrcid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.SignalingCreateReq} returns this
 */
proto.himpb.SignalingCreateReq.prototype.setSrcid = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string customInfo = 8;
 * @return {string}
 */
proto.himpb.SignalingCreateReq.prototype.getCustominfo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.SignalingCreateReq} returns this
 */
proto.himpb.SignalingCreateReq.prototype.setCustominfo = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.himpb.SignalingCreateRsp.prototype.toObject = function(opt_includeInstance) {
  return proto.himpb.SignalingCreateRsp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.himpb.SignalingCreateRsp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.SignalingCreateRsp.toObject = function(includeInstance, msg) {
  var f, obj = {
    base: (f = msg.getBase()) && header_entity_pb.RspBase.toObject(includeInstance, f),
    info: (f = msg.getInfo()) && signaling_param_pb.TSigSessionInfo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.himpb.SignalingCreateRsp}
 */
proto.himpb.SignalingCreateRsp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.himpb.SignalingCreateRsp;
  return proto.himpb.SignalingCreateRsp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.himpb.SignalingCreateRsp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.himpb.SignalingCreateRsp}
 */
proto.himpb.SignalingCreateRsp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new header_entity_pb.RspBase;
      reader.readMessage(value,header_entity_pb.RspBase.deserializeBinaryFromReader);
      msg.setBase(value);
      break;
    case 2:
      var value = new signaling_param_pb.TSigSessionInfo;
      reader.readMessage(value,signaling_param_pb.TSigSessionInfo.deserializeBinaryFromReader);
      msg.setInfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.himpb.SignalingCreateRsp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.himpb.SignalingCreateRsp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.himpb.SignalingCreateRsp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.SignalingCreateRsp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBase();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      header_entity_pb.RspBase.serializeBinaryToWriter
    );
  }
  f = message.getInfo();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      signaling_param_pb.TSigSessionInfo.serializeBinaryToWriter
    );
  }
};


/**
 * optional RspBase base = 1;
 * @return {?proto.himpb.RspBase}
 */
proto.himpb.SignalingCreateRsp.prototype.getBase = function() {
  return /** @type{?proto.himpb.RspBase} */ (
    jspb.Message.getWrapperField(this, header_entity_pb.RspBase, 1));
};


/**
 * @param {?proto.himpb.RspBase|undefined} value
 * @return {!proto.himpb.SignalingCreateRsp} returns this
*/
proto.himpb.SignalingCreateRsp.prototype.setBase = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.himpb.SignalingCreateRsp} returns this
 */
proto.himpb.SignalingCreateRsp.prototype.clearBase = function() {
  return this.setBase(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.himpb.SignalingCreateRsp.prototype.hasBase = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional TSigSessionInfo info = 2;
 * @return {?proto.himpb.TSigSessionInfo}
 */
proto.himpb.SignalingCreateRsp.prototype.getInfo = function() {
  return /** @type{?proto.himpb.TSigSessionInfo} */ (
    jspb.Message.getWrapperField(this, signaling_param_pb.TSigSessionInfo, 2));
};


/**
 * @param {?proto.himpb.TSigSessionInfo|undefined} value
 * @return {!proto.himpb.SignalingCreateRsp} returns this
*/
proto.himpb.SignalingCreateRsp.prototype.setInfo = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.himpb.SignalingCreateRsp} returns this
 */
proto.himpb.SignalingCreateRsp.prototype.clearInfo = function() {
  return this.setInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.himpb.SignalingCreateRsp.prototype.hasInfo = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.himpb.SignalingCloseReq.prototype.toObject = function(opt_includeInstance) {
  return proto.himpb.SignalingCloseReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.himpb.SignalingCloseReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.SignalingCloseReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    base: (f = msg.getBase()) && header_entity_pb.ReqBase.toObject(includeInstance, f),
    roomid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    roomkey: jspb.Message.getFieldWithDefault(msg, 3, 0),
    offlineenabled: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    custominfo: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.himpb.SignalingCloseReq}
 */
proto.himpb.SignalingCloseReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.himpb.SignalingCloseReq;
  return proto.himpb.SignalingCloseReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.himpb.SignalingCloseReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.himpb.SignalingCloseReq}
 */
proto.himpb.SignalingCloseReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new header_entity_pb.ReqBase;
      reader.readMessage(value,header_entity_pb.ReqBase.deserializeBinaryFromReader);
      msg.setBase(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRoomid(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setRoomkey(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setOfflineenabled(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setCustominfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.himpb.SignalingCloseReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.himpb.SignalingCloseReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.himpb.SignalingCloseReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.SignalingCloseReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBase();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      header_entity_pb.ReqBase.serializeBinaryToWriter
    );
  }
  f = message.getRoomid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRoomkey();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getOfflineenabled();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getCustominfo();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional ReqBase base = 1;
 * @return {?proto.himpb.ReqBase}
 */
proto.himpb.SignalingCloseReq.prototype.getBase = function() {
  return /** @type{?proto.himpb.ReqBase} */ (
    jspb.Message.getWrapperField(this, header_entity_pb.ReqBase, 1));
};


/**
 * @param {?proto.himpb.ReqBase|undefined} value
 * @return {!proto.himpb.SignalingCloseReq} returns this
*/
proto.himpb.SignalingCloseReq.prototype.setBase = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.himpb.SignalingCloseReq} returns this
 */
proto.himpb.SignalingCloseReq.prototype.clearBase = function() {
  return this.setBase(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.himpb.SignalingCloseReq.prototype.hasBase = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string roomId = 2;
 * @return {string}
 */
proto.himpb.SignalingCloseReq.prototype.getRoomid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.SignalingCloseReq} returns this
 */
proto.himpb.SignalingCloseReq.prototype.setRoomid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint32 roomKey = 3;
 * @return {number}
 */
proto.himpb.SignalingCloseReq.prototype.getRoomkey = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.SignalingCloseReq} returns this
 */
proto.himpb.SignalingCloseReq.prototype.setRoomkey = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional bool offlineEnabled = 4;
 * @return {boolean}
 */
proto.himpb.SignalingCloseReq.prototype.getOfflineenabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.himpb.SignalingCloseReq} returns this
 */
proto.himpb.SignalingCloseReq.prototype.setOfflineenabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional string customInfo = 5;
 * @return {string}
 */
proto.himpb.SignalingCloseReq.prototype.getCustominfo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.SignalingCloseReq} returns this
 */
proto.himpb.SignalingCloseReq.prototype.setCustominfo = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.himpb.SignalingCloseRsp.prototype.toObject = function(opt_includeInstance) {
  return proto.himpb.SignalingCloseRsp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.himpb.SignalingCloseRsp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.SignalingCloseRsp.toObject = function(includeInstance, msg) {
  var f, obj = {
    base: (f = msg.getBase()) && header_entity_pb.RspBase.toObject(includeInstance, f),
    roomid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    record: (f = msg.getRecord()) && signaling_param_pb.TSigSessionEndRecord.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.himpb.SignalingCloseRsp}
 */
proto.himpb.SignalingCloseRsp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.himpb.SignalingCloseRsp;
  return proto.himpb.SignalingCloseRsp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.himpb.SignalingCloseRsp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.himpb.SignalingCloseRsp}
 */
proto.himpb.SignalingCloseRsp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new header_entity_pb.RspBase;
      reader.readMessage(value,header_entity_pb.RspBase.deserializeBinaryFromReader);
      msg.setBase(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRoomid(value);
      break;
    case 3:
      var value = new signaling_param_pb.TSigSessionEndRecord;
      reader.readMessage(value,signaling_param_pb.TSigSessionEndRecord.deserializeBinaryFromReader);
      msg.setRecord(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.himpb.SignalingCloseRsp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.himpb.SignalingCloseRsp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.himpb.SignalingCloseRsp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.SignalingCloseRsp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBase();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      header_entity_pb.RspBase.serializeBinaryToWriter
    );
  }
  f = message.getRoomid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRecord();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      signaling_param_pb.TSigSessionEndRecord.serializeBinaryToWriter
    );
  }
};


/**
 * optional RspBase base = 1;
 * @return {?proto.himpb.RspBase}
 */
proto.himpb.SignalingCloseRsp.prototype.getBase = function() {
  return /** @type{?proto.himpb.RspBase} */ (
    jspb.Message.getWrapperField(this, header_entity_pb.RspBase, 1));
};


/**
 * @param {?proto.himpb.RspBase|undefined} value
 * @return {!proto.himpb.SignalingCloseRsp} returns this
*/
proto.himpb.SignalingCloseRsp.prototype.setBase = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.himpb.SignalingCloseRsp} returns this
 */
proto.himpb.SignalingCloseRsp.prototype.clearBase = function() {
  return this.setBase(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.himpb.SignalingCloseRsp.prototype.hasBase = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string roomId = 2;
 * @return {string}
 */
proto.himpb.SignalingCloseRsp.prototype.getRoomid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.SignalingCloseRsp} returns this
 */
proto.himpb.SignalingCloseRsp.prototype.setRoomid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional TSigSessionEndRecord record = 3;
 * @return {?proto.himpb.TSigSessionEndRecord}
 */
proto.himpb.SignalingCloseRsp.prototype.getRecord = function() {
  return /** @type{?proto.himpb.TSigSessionEndRecord} */ (
    jspb.Message.getWrapperField(this, signaling_param_pb.TSigSessionEndRecord, 3));
};


/**
 * @param {?proto.himpb.TSigSessionEndRecord|undefined} value
 * @return {!proto.himpb.SignalingCloseRsp} returns this
*/
proto.himpb.SignalingCloseRsp.prototype.setRecord = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.himpb.SignalingCloseRsp} returns this
 */
proto.himpb.SignalingCloseRsp.prototype.clearRecord = function() {
  return this.setRecord(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.himpb.SignalingCloseRsp.prototype.hasRecord = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.himpb.SignalingInviteReq.repeatedFields_ = [14,16];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.himpb.SignalingInviteReq.prototype.toObject = function(opt_includeInstance) {
  return proto.himpb.SignalingInviteReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.himpb.SignalingInviteReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.SignalingInviteReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    base: (f = msg.getBase()) && header_entity_pb.ReqBase.toObject(includeInstance, f),
    type: jspb.Message.getFieldWithDefault(msg, 2, 0),
    roomid: jspb.Message.getFieldWithDefault(msg, 3, ""),
    roomkey: jspb.Message.getFieldWithDefault(msg, 4, 0),
    roomname: jspb.Message.getFieldWithDefault(msg, 5, ""),
    roomextinfo: jspb.Message.getFieldWithDefault(msg, 6, ""),
    invitername: jspb.Message.getFieldWithDefault(msg, 7, ""),
    source: jspb.Message.getFieldWithDefault(msg, 8, 0),
    srcid: jspb.Message.getFieldWithDefault(msg, 9, ""),
    requestid: jspb.Message.getFieldWithDefault(msg, 10, ""),
    custominfo: jspb.Message.getFieldWithDefault(msg, 11, ""),
    offlineenabled: jspb.Message.getBooleanFieldWithDefault(msg, 12, false),
    pushinfo: jspb.Message.getFieldWithDefault(msg, 13, ""),
    peeridsList: (f = jspb.Message.getRepeatedField(msg, 14)) == null ? undefined : f,
    contactsList: jspb.Message.toObjectList(msg.getContactsList(),
    header_entity_pb.TContactInfo.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.himpb.SignalingInviteReq}
 */
proto.himpb.SignalingInviteReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.himpb.SignalingInviteReq;
  return proto.himpb.SignalingInviteReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.himpb.SignalingInviteReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.himpb.SignalingInviteReq}
 */
proto.himpb.SignalingInviteReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new header_entity_pb.ReqBase;
      reader.readMessage(value,header_entity_pb.ReqBase.deserializeBinaryFromReader);
      msg.setBase(value);
      break;
    case 2:
      var value = /** @type {!proto.himpb.ESig.SessionType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setRoomid(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setRoomkey(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setRoomname(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setRoomextinfo(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setInvitername(value);
      break;
    case 8:
      var value = /** @type {!proto.himpb.ESig.SourceType} */ (reader.readEnum());
      msg.setSource(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setSrcid(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestid(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setCustominfo(value);
      break;
    case 12:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setOfflineenabled(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setPushinfo(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.addPeerids(value);
      break;
    case 16:
      var value = new header_entity_pb.TContactInfo;
      reader.readMessage(value,header_entity_pb.TContactInfo.deserializeBinaryFromReader);
      msg.addContacts(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.himpb.SignalingInviteReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.himpb.SignalingInviteReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.himpb.SignalingInviteReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.SignalingInviteReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBase();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      header_entity_pb.ReqBase.serializeBinaryToWriter
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getRoomid();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getRoomkey();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
  f = message.getRoomname();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getRoomextinfo();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getInvitername();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getSource();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
  f = message.getSrcid();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getRequestid();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getCustominfo();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getOfflineenabled();
  if (f) {
    writer.writeBool(
      12,
      f
    );
  }
  f = message.getPushinfo();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getPeeridsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      14,
      f
    );
  }
  f = message.getContactsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      16,
      f,
      header_entity_pb.TContactInfo.serializeBinaryToWriter
    );
  }
};


/**
 * optional ReqBase base = 1;
 * @return {?proto.himpb.ReqBase}
 */
proto.himpb.SignalingInviteReq.prototype.getBase = function() {
  return /** @type{?proto.himpb.ReqBase} */ (
    jspb.Message.getWrapperField(this, header_entity_pb.ReqBase, 1));
};


/**
 * @param {?proto.himpb.ReqBase|undefined} value
 * @return {!proto.himpb.SignalingInviteReq} returns this
*/
proto.himpb.SignalingInviteReq.prototype.setBase = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.himpb.SignalingInviteReq} returns this
 */
proto.himpb.SignalingInviteReq.prototype.clearBase = function() {
  return this.setBase(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.himpb.SignalingInviteReq.prototype.hasBase = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional ESig.SessionType type = 2;
 * @return {!proto.himpb.ESig.SessionType}
 */
proto.himpb.SignalingInviteReq.prototype.getType = function() {
  return /** @type {!proto.himpb.ESig.SessionType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.himpb.ESig.SessionType} value
 * @return {!proto.himpb.SignalingInviteReq} returns this
 */
proto.himpb.SignalingInviteReq.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string roomId = 3;
 * @return {string}
 */
proto.himpb.SignalingInviteReq.prototype.getRoomid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.SignalingInviteReq} returns this
 */
proto.himpb.SignalingInviteReq.prototype.setRoomid = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional uint32 roomKey = 4;
 * @return {number}
 */
proto.himpb.SignalingInviteReq.prototype.getRoomkey = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.SignalingInviteReq} returns this
 */
proto.himpb.SignalingInviteReq.prototype.setRoomkey = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string roomName = 5;
 * @return {string}
 */
proto.himpb.SignalingInviteReq.prototype.getRoomname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.SignalingInviteReq} returns this
 */
proto.himpb.SignalingInviteReq.prototype.setRoomname = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string roomExtInfo = 6;
 * @return {string}
 */
proto.himpb.SignalingInviteReq.prototype.getRoomextinfo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.SignalingInviteReq} returns this
 */
proto.himpb.SignalingInviteReq.prototype.setRoomextinfo = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string inviterName = 7;
 * @return {string}
 */
proto.himpb.SignalingInviteReq.prototype.getInvitername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.SignalingInviteReq} returns this
 */
proto.himpb.SignalingInviteReq.prototype.setInvitername = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional ESig.SourceType source = 8;
 * @return {!proto.himpb.ESig.SourceType}
 */
proto.himpb.SignalingInviteReq.prototype.getSource = function() {
  return /** @type {!proto.himpb.ESig.SourceType} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {!proto.himpb.ESig.SourceType} value
 * @return {!proto.himpb.SignalingInviteReq} returns this
 */
proto.himpb.SignalingInviteReq.prototype.setSource = function(value) {
  return jspb.Message.setProto3EnumField(this, 8, value);
};


/**
 * optional string srcId = 9;
 * @return {string}
 */
proto.himpb.SignalingInviteReq.prototype.getSrcid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.SignalingInviteReq} returns this
 */
proto.himpb.SignalingInviteReq.prototype.setSrcid = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string requestId = 10;
 * @return {string}
 */
proto.himpb.SignalingInviteReq.prototype.getRequestid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.SignalingInviteReq} returns this
 */
proto.himpb.SignalingInviteReq.prototype.setRequestid = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string customInfo = 11;
 * @return {string}
 */
proto.himpb.SignalingInviteReq.prototype.getCustominfo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.SignalingInviteReq} returns this
 */
proto.himpb.SignalingInviteReq.prototype.setCustominfo = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional bool offlineEnabled = 12;
 * @return {boolean}
 */
proto.himpb.SignalingInviteReq.prototype.getOfflineenabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 12, false));
};


/**
 * @param {boolean} value
 * @return {!proto.himpb.SignalingInviteReq} returns this
 */
proto.himpb.SignalingInviteReq.prototype.setOfflineenabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 12, value);
};


/**
 * optional string pushInfo = 13;
 * @return {string}
 */
proto.himpb.SignalingInviteReq.prototype.getPushinfo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.SignalingInviteReq} returns this
 */
proto.himpb.SignalingInviteReq.prototype.setPushinfo = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * repeated string peerIds = 14;
 * @return {!Array<string>}
 */
proto.himpb.SignalingInviteReq.prototype.getPeeridsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 14));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.himpb.SignalingInviteReq} returns this
 */
proto.himpb.SignalingInviteReq.prototype.setPeeridsList = function(value) {
  return jspb.Message.setField(this, 14, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.himpb.SignalingInviteReq} returns this
 */
proto.himpb.SignalingInviteReq.prototype.addPeerids = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 14, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.himpb.SignalingInviteReq} returns this
 */
proto.himpb.SignalingInviteReq.prototype.clearPeeridsList = function() {
  return this.setPeeridsList([]);
};


/**
 * repeated TContactInfo contacts = 16;
 * @return {!Array<!proto.himpb.TContactInfo>}
 */
proto.himpb.SignalingInviteReq.prototype.getContactsList = function() {
  return /** @type{!Array<!proto.himpb.TContactInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, header_entity_pb.TContactInfo, 16));
};


/**
 * @param {!Array<!proto.himpb.TContactInfo>} value
 * @return {!proto.himpb.SignalingInviteReq} returns this
*/
proto.himpb.SignalingInviteReq.prototype.setContactsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 16, value);
};


/**
 * @param {!proto.himpb.TContactInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.himpb.TContactInfo}
 */
proto.himpb.SignalingInviteReq.prototype.addContacts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 16, opt_value, proto.himpb.TContactInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.himpb.SignalingInviteReq} returns this
 */
proto.himpb.SignalingInviteReq.prototype.clearContactsList = function() {
  return this.setContactsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.himpb.SignalingInviteRsp.repeatedFields_ = [7,10,11];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.himpb.SignalingInviteRsp.prototype.toObject = function(opt_includeInstance) {
  return proto.himpb.SignalingInviteRsp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.himpb.SignalingInviteRsp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.SignalingInviteRsp.toObject = function(includeInstance, msg) {
  var f, obj = {
    base: (f = msg.getBase()) && header_entity_pb.RspBase.toObject(includeInstance, f),
    roomid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    source: jspb.Message.getFieldWithDefault(msg, 3, 0),
    srcid: jspb.Message.getFieldWithDefault(msg, 4, ""),
    invitets: jspb.Message.getFieldWithDefault(msg, 5, 0),
    info: (f = msg.getInfo()) && signaling_param_pb.TSigSessionInfo.toObject(includeInstance, f),
    membersList: jspb.Message.toObjectList(msg.getMembersList(),
    signaling_param_pb.TSigMemberInfo.toObject, includeInstance),
    requestid: jspb.Message.getFieldWithDefault(msg, 8, ""),
    custominfo: jspb.Message.getFieldWithDefault(msg, 9, ""),
    peeridsList: (f = jspb.Message.getRepeatedField(msg, 10)) == null ? undefined : f,
    inviteesList: jspb.Message.toObjectList(msg.getInviteesList(),
    header_entity_pb.TContactInfo.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.himpb.SignalingInviteRsp}
 */
proto.himpb.SignalingInviteRsp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.himpb.SignalingInviteRsp;
  return proto.himpb.SignalingInviteRsp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.himpb.SignalingInviteRsp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.himpb.SignalingInviteRsp}
 */
proto.himpb.SignalingInviteRsp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new header_entity_pb.RspBase;
      reader.readMessage(value,header_entity_pb.RspBase.deserializeBinaryFromReader);
      msg.setBase(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRoomid(value);
      break;
    case 3:
      var value = /** @type {!proto.himpb.ESig.SourceType} */ (reader.readEnum());
      msg.setSource(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSrcid(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setInvitets(value);
      break;
    case 6:
      var value = new signaling_param_pb.TSigSessionInfo;
      reader.readMessage(value,signaling_param_pb.TSigSessionInfo.deserializeBinaryFromReader);
      msg.setInfo(value);
      break;
    case 7:
      var value = new signaling_param_pb.TSigMemberInfo;
      reader.readMessage(value,signaling_param_pb.TSigMemberInfo.deserializeBinaryFromReader);
      msg.addMembers(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestid(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setCustominfo(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.addPeerids(value);
      break;
    case 11:
      var value = new header_entity_pb.TContactInfo;
      reader.readMessage(value,header_entity_pb.TContactInfo.deserializeBinaryFromReader);
      msg.addInvitees(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.himpb.SignalingInviteRsp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.himpb.SignalingInviteRsp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.himpb.SignalingInviteRsp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.SignalingInviteRsp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBase();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      header_entity_pb.RspBase.serializeBinaryToWriter
    );
  }
  f = message.getRoomid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSource();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getSrcid();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getInvitets();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getInfo();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      signaling_param_pb.TSigSessionInfo.serializeBinaryToWriter
    );
  }
  f = message.getMembersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      signaling_param_pb.TSigMemberInfo.serializeBinaryToWriter
    );
  }
  f = message.getRequestid();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getCustominfo();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getPeeridsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      10,
      f
    );
  }
  f = message.getInviteesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      11,
      f,
      header_entity_pb.TContactInfo.serializeBinaryToWriter
    );
  }
};


/**
 * optional RspBase base = 1;
 * @return {?proto.himpb.RspBase}
 */
proto.himpb.SignalingInviteRsp.prototype.getBase = function() {
  return /** @type{?proto.himpb.RspBase} */ (
    jspb.Message.getWrapperField(this, header_entity_pb.RspBase, 1));
};


/**
 * @param {?proto.himpb.RspBase|undefined} value
 * @return {!proto.himpb.SignalingInviteRsp} returns this
*/
proto.himpb.SignalingInviteRsp.prototype.setBase = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.himpb.SignalingInviteRsp} returns this
 */
proto.himpb.SignalingInviteRsp.prototype.clearBase = function() {
  return this.setBase(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.himpb.SignalingInviteRsp.prototype.hasBase = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string roomId = 2;
 * @return {string}
 */
proto.himpb.SignalingInviteRsp.prototype.getRoomid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.SignalingInviteRsp} returns this
 */
proto.himpb.SignalingInviteRsp.prototype.setRoomid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional ESig.SourceType source = 3;
 * @return {!proto.himpb.ESig.SourceType}
 */
proto.himpb.SignalingInviteRsp.prototype.getSource = function() {
  return /** @type {!proto.himpb.ESig.SourceType} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.himpb.ESig.SourceType} value
 * @return {!proto.himpb.SignalingInviteRsp} returns this
 */
proto.himpb.SignalingInviteRsp.prototype.setSource = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional string srcId = 4;
 * @return {string}
 */
proto.himpb.SignalingInviteRsp.prototype.getSrcid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.SignalingInviteRsp} returns this
 */
proto.himpb.SignalingInviteRsp.prototype.setSrcid = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int64 inviteTs = 5;
 * @return {number}
 */
proto.himpb.SignalingInviteRsp.prototype.getInvitets = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.SignalingInviteRsp} returns this
 */
proto.himpb.SignalingInviteRsp.prototype.setInvitets = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional TSigSessionInfo info = 6;
 * @return {?proto.himpb.TSigSessionInfo}
 */
proto.himpb.SignalingInviteRsp.prototype.getInfo = function() {
  return /** @type{?proto.himpb.TSigSessionInfo} */ (
    jspb.Message.getWrapperField(this, signaling_param_pb.TSigSessionInfo, 6));
};


/**
 * @param {?proto.himpb.TSigSessionInfo|undefined} value
 * @return {!proto.himpb.SignalingInviteRsp} returns this
*/
proto.himpb.SignalingInviteRsp.prototype.setInfo = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.himpb.SignalingInviteRsp} returns this
 */
proto.himpb.SignalingInviteRsp.prototype.clearInfo = function() {
  return this.setInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.himpb.SignalingInviteRsp.prototype.hasInfo = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * repeated TSigMemberInfo members = 7;
 * @return {!Array<!proto.himpb.TSigMemberInfo>}
 */
proto.himpb.SignalingInviteRsp.prototype.getMembersList = function() {
  return /** @type{!Array<!proto.himpb.TSigMemberInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, signaling_param_pb.TSigMemberInfo, 7));
};


/**
 * @param {!Array<!proto.himpb.TSigMemberInfo>} value
 * @return {!proto.himpb.SignalingInviteRsp} returns this
*/
proto.himpb.SignalingInviteRsp.prototype.setMembersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.himpb.TSigMemberInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.himpb.TSigMemberInfo}
 */
proto.himpb.SignalingInviteRsp.prototype.addMembers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.himpb.TSigMemberInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.himpb.SignalingInviteRsp} returns this
 */
proto.himpb.SignalingInviteRsp.prototype.clearMembersList = function() {
  return this.setMembersList([]);
};


/**
 * optional string requestId = 8;
 * @return {string}
 */
proto.himpb.SignalingInviteRsp.prototype.getRequestid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.SignalingInviteRsp} returns this
 */
proto.himpb.SignalingInviteRsp.prototype.setRequestid = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string customInfo = 9;
 * @return {string}
 */
proto.himpb.SignalingInviteRsp.prototype.getCustominfo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.SignalingInviteRsp} returns this
 */
proto.himpb.SignalingInviteRsp.prototype.setCustominfo = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * repeated string peerIds = 10;
 * @return {!Array<string>}
 */
proto.himpb.SignalingInviteRsp.prototype.getPeeridsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 10));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.himpb.SignalingInviteRsp} returns this
 */
proto.himpb.SignalingInviteRsp.prototype.setPeeridsList = function(value) {
  return jspb.Message.setField(this, 10, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.himpb.SignalingInviteRsp} returns this
 */
proto.himpb.SignalingInviteRsp.prototype.addPeerids = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 10, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.himpb.SignalingInviteRsp} returns this
 */
proto.himpb.SignalingInviteRsp.prototype.clearPeeridsList = function() {
  return this.setPeeridsList([]);
};


/**
 * repeated TContactInfo invitees = 11;
 * @return {!Array<!proto.himpb.TContactInfo>}
 */
proto.himpb.SignalingInviteRsp.prototype.getInviteesList = function() {
  return /** @type{!Array<!proto.himpb.TContactInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, header_entity_pb.TContactInfo, 11));
};


/**
 * @param {!Array<!proto.himpb.TContactInfo>} value
 * @return {!proto.himpb.SignalingInviteRsp} returns this
*/
proto.himpb.SignalingInviteRsp.prototype.setInviteesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 11, value);
};


/**
 * @param {!proto.himpb.TContactInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.himpb.TContactInfo}
 */
proto.himpb.SignalingInviteRsp.prototype.addInvitees = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 11, opt_value, proto.himpb.TContactInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.himpb.SignalingInviteRsp} returns this
 */
proto.himpb.SignalingInviteRsp.prototype.clearInviteesList = function() {
  return this.setInviteesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.himpb.SignalingInviteRelayNty.repeatedFields_ = [7,8];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.himpb.SignalingInviteRelayNty.prototype.toObject = function(opt_includeInstance) {
  return proto.himpb.SignalingInviteRelayNty.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.himpb.SignalingInviteRelayNty} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.SignalingInviteRelayNty.toObject = function(includeInstance, msg) {
  var f, obj = {
    base: (f = msg.getBase()) && header_entity_pb.ReqBase.toObject(includeInstance, f),
    info: (f = msg.getInfo()) && signaling_param_pb.TSigSessionInfo.toObject(includeInstance, f),
    invitets: jspb.Message.getFieldWithDefault(msg, 3, 0),
    requestid: jspb.Message.getFieldWithDefault(msg, 4, ""),
    inviterid: jspb.Message.getFieldWithDefault(msg, 5, ""),
    custominfo: jspb.Message.getFieldWithDefault(msg, 6, ""),
    membersList: jspb.Message.toObjectList(msg.getMembersList(),
    signaling_param_pb.TSigMemberInfo.toObject, includeInstance),
    peeridsList: (f = jspb.Message.getRepeatedField(msg, 8)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.himpb.SignalingInviteRelayNty}
 */
proto.himpb.SignalingInviteRelayNty.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.himpb.SignalingInviteRelayNty;
  return proto.himpb.SignalingInviteRelayNty.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.himpb.SignalingInviteRelayNty} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.himpb.SignalingInviteRelayNty}
 */
proto.himpb.SignalingInviteRelayNty.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new header_entity_pb.ReqBase;
      reader.readMessage(value,header_entity_pb.ReqBase.deserializeBinaryFromReader);
      msg.setBase(value);
      break;
    case 2:
      var value = new signaling_param_pb.TSigSessionInfo;
      reader.readMessage(value,signaling_param_pb.TSigSessionInfo.deserializeBinaryFromReader);
      msg.setInfo(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setInvitets(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestid(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setInviterid(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setCustominfo(value);
      break;
    case 7:
      var value = new signaling_param_pb.TSigMemberInfo;
      reader.readMessage(value,signaling_param_pb.TSigMemberInfo.deserializeBinaryFromReader);
      msg.addMembers(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.addPeerids(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.himpb.SignalingInviteRelayNty.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.himpb.SignalingInviteRelayNty.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.himpb.SignalingInviteRelayNty} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.SignalingInviteRelayNty.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBase();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      header_entity_pb.ReqBase.serializeBinaryToWriter
    );
  }
  f = message.getInfo();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      signaling_param_pb.TSigSessionInfo.serializeBinaryToWriter
    );
  }
  f = message.getInvitets();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getRequestid();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getInviterid();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getCustominfo();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getMembersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      signaling_param_pb.TSigMemberInfo.serializeBinaryToWriter
    );
  }
  f = message.getPeeridsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      8,
      f
    );
  }
};


/**
 * optional ReqBase base = 1;
 * @return {?proto.himpb.ReqBase}
 */
proto.himpb.SignalingInviteRelayNty.prototype.getBase = function() {
  return /** @type{?proto.himpb.ReqBase} */ (
    jspb.Message.getWrapperField(this, header_entity_pb.ReqBase, 1));
};


/**
 * @param {?proto.himpb.ReqBase|undefined} value
 * @return {!proto.himpb.SignalingInviteRelayNty} returns this
*/
proto.himpb.SignalingInviteRelayNty.prototype.setBase = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.himpb.SignalingInviteRelayNty} returns this
 */
proto.himpb.SignalingInviteRelayNty.prototype.clearBase = function() {
  return this.setBase(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.himpb.SignalingInviteRelayNty.prototype.hasBase = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional TSigSessionInfo info = 2;
 * @return {?proto.himpb.TSigSessionInfo}
 */
proto.himpb.SignalingInviteRelayNty.prototype.getInfo = function() {
  return /** @type{?proto.himpb.TSigSessionInfo} */ (
    jspb.Message.getWrapperField(this, signaling_param_pb.TSigSessionInfo, 2));
};


/**
 * @param {?proto.himpb.TSigSessionInfo|undefined} value
 * @return {!proto.himpb.SignalingInviteRelayNty} returns this
*/
proto.himpb.SignalingInviteRelayNty.prototype.setInfo = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.himpb.SignalingInviteRelayNty} returns this
 */
proto.himpb.SignalingInviteRelayNty.prototype.clearInfo = function() {
  return this.setInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.himpb.SignalingInviteRelayNty.prototype.hasInfo = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int64 inviteTs = 3;
 * @return {number}
 */
proto.himpb.SignalingInviteRelayNty.prototype.getInvitets = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.SignalingInviteRelayNty} returns this
 */
proto.himpb.SignalingInviteRelayNty.prototype.setInvitets = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string requestId = 4;
 * @return {string}
 */
proto.himpb.SignalingInviteRelayNty.prototype.getRequestid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.SignalingInviteRelayNty} returns this
 */
proto.himpb.SignalingInviteRelayNty.prototype.setRequestid = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string inviterId = 5;
 * @return {string}
 */
proto.himpb.SignalingInviteRelayNty.prototype.getInviterid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.SignalingInviteRelayNty} returns this
 */
proto.himpb.SignalingInviteRelayNty.prototype.setInviterid = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string customInfo = 6;
 * @return {string}
 */
proto.himpb.SignalingInviteRelayNty.prototype.getCustominfo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.SignalingInviteRelayNty} returns this
 */
proto.himpb.SignalingInviteRelayNty.prototype.setCustominfo = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * repeated TSigMemberInfo members = 7;
 * @return {!Array<!proto.himpb.TSigMemberInfo>}
 */
proto.himpb.SignalingInviteRelayNty.prototype.getMembersList = function() {
  return /** @type{!Array<!proto.himpb.TSigMemberInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, signaling_param_pb.TSigMemberInfo, 7));
};


/**
 * @param {!Array<!proto.himpb.TSigMemberInfo>} value
 * @return {!proto.himpb.SignalingInviteRelayNty} returns this
*/
proto.himpb.SignalingInviteRelayNty.prototype.setMembersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.himpb.TSigMemberInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.himpb.TSigMemberInfo}
 */
proto.himpb.SignalingInviteRelayNty.prototype.addMembers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.himpb.TSigMemberInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.himpb.SignalingInviteRelayNty} returns this
 */
proto.himpb.SignalingInviteRelayNty.prototype.clearMembersList = function() {
  return this.setMembersList([]);
};


/**
 * repeated string peerIds = 8;
 * @return {!Array<string>}
 */
proto.himpb.SignalingInviteRelayNty.prototype.getPeeridsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 8));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.himpb.SignalingInviteRelayNty} returns this
 */
proto.himpb.SignalingInviteRelayNty.prototype.setPeeridsList = function(value) {
  return jspb.Message.setField(this, 8, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.himpb.SignalingInviteRelayNty} returns this
 */
proto.himpb.SignalingInviteRelayNty.prototype.addPeerids = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 8, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.himpb.SignalingInviteRelayNty} returns this
 */
proto.himpb.SignalingInviteRelayNty.prototype.clearPeeridsList = function() {
  return this.setPeeridsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.himpb.SignalingUserJoinedNty.repeatedFields_ = [3,15];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.himpb.SignalingUserJoinedNty.prototype.toObject = function(opt_includeInstance) {
  return proto.himpb.SignalingUserJoinedNty.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.himpb.SignalingUserJoinedNty} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.SignalingUserJoinedNty.toObject = function(includeInstance, msg) {
  var f, obj = {
    base: (f = msg.getBase()) && header_entity_pb.ReqBase.toObject(includeInstance, f),
    roomid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    membersList: jspb.Message.toObjectList(msg.getMembersList(),
    signaling_param_pb.TSigMemberInfo.toObject, includeInstance),
    receiversList: (f = jspb.Message.getRepeatedField(msg, 15)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.himpb.SignalingUserJoinedNty}
 */
proto.himpb.SignalingUserJoinedNty.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.himpb.SignalingUserJoinedNty;
  return proto.himpb.SignalingUserJoinedNty.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.himpb.SignalingUserJoinedNty} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.himpb.SignalingUserJoinedNty}
 */
proto.himpb.SignalingUserJoinedNty.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new header_entity_pb.ReqBase;
      reader.readMessage(value,header_entity_pb.ReqBase.deserializeBinaryFromReader);
      msg.setBase(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRoomid(value);
      break;
    case 3:
      var value = new signaling_param_pb.TSigMemberInfo;
      reader.readMessage(value,signaling_param_pb.TSigMemberInfo.deserializeBinaryFromReader);
      msg.addMembers(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.addReceivers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.himpb.SignalingUserJoinedNty.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.himpb.SignalingUserJoinedNty.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.himpb.SignalingUserJoinedNty} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.SignalingUserJoinedNty.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBase();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      header_entity_pb.ReqBase.serializeBinaryToWriter
    );
  }
  f = message.getRoomid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getMembersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      signaling_param_pb.TSigMemberInfo.serializeBinaryToWriter
    );
  }
  f = message.getReceiversList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      15,
      f
    );
  }
};


/**
 * optional ReqBase base = 1;
 * @return {?proto.himpb.ReqBase}
 */
proto.himpb.SignalingUserJoinedNty.prototype.getBase = function() {
  return /** @type{?proto.himpb.ReqBase} */ (
    jspb.Message.getWrapperField(this, header_entity_pb.ReqBase, 1));
};


/**
 * @param {?proto.himpb.ReqBase|undefined} value
 * @return {!proto.himpb.SignalingUserJoinedNty} returns this
*/
proto.himpb.SignalingUserJoinedNty.prototype.setBase = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.himpb.SignalingUserJoinedNty} returns this
 */
proto.himpb.SignalingUserJoinedNty.prototype.clearBase = function() {
  return this.setBase(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.himpb.SignalingUserJoinedNty.prototype.hasBase = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string roomId = 2;
 * @return {string}
 */
proto.himpb.SignalingUserJoinedNty.prototype.getRoomid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.SignalingUserJoinedNty} returns this
 */
proto.himpb.SignalingUserJoinedNty.prototype.setRoomid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated TSigMemberInfo members = 3;
 * @return {!Array<!proto.himpb.TSigMemberInfo>}
 */
proto.himpb.SignalingUserJoinedNty.prototype.getMembersList = function() {
  return /** @type{!Array<!proto.himpb.TSigMemberInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, signaling_param_pb.TSigMemberInfo, 3));
};


/**
 * @param {!Array<!proto.himpb.TSigMemberInfo>} value
 * @return {!proto.himpb.SignalingUserJoinedNty} returns this
*/
proto.himpb.SignalingUserJoinedNty.prototype.setMembersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.himpb.TSigMemberInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.himpb.TSigMemberInfo}
 */
proto.himpb.SignalingUserJoinedNty.prototype.addMembers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.himpb.TSigMemberInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.himpb.SignalingUserJoinedNty} returns this
 */
proto.himpb.SignalingUserJoinedNty.prototype.clearMembersList = function() {
  return this.setMembersList([]);
};


/**
 * repeated string receivers = 15;
 * @return {!Array<string>}
 */
proto.himpb.SignalingUserJoinedNty.prototype.getReceiversList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 15));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.himpb.SignalingUserJoinedNty} returns this
 */
proto.himpb.SignalingUserJoinedNty.prototype.setReceiversList = function(value) {
  return jspb.Message.setField(this, 15, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.himpb.SignalingUserJoinedNty} returns this
 */
proto.himpb.SignalingUserJoinedNty.prototype.addReceivers = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 15, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.himpb.SignalingUserJoinedNty} returns this
 */
proto.himpb.SignalingUserJoinedNty.prototype.clearReceiversList = function() {
  return this.setReceiversList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.himpb.SignalingInviteOfflineRelayNty.repeatedFields_ = [7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.himpb.SignalingInviteOfflineRelayNty.prototype.toObject = function(opt_includeInstance) {
  return proto.himpb.SignalingInviteOfflineRelayNty.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.himpb.SignalingInviteOfflineRelayNty} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.SignalingInviteOfflineRelayNty.toObject = function(includeInstance, msg) {
  var f, obj = {
    base: (f = msg.getBase()) && header_entity_pb.ReqBase.toObject(includeInstance, f),
    info: (f = msg.getInfo()) && signaling_param_pb.TSigSessionInfo.toObject(includeInstance, f),
    invitets: jspb.Message.getFieldWithDefault(msg, 3, 0),
    requestid: jspb.Message.getFieldWithDefault(msg, 4, ""),
    inviterid: jspb.Message.getFieldWithDefault(msg, 5, ""),
    custominfo: jspb.Message.getFieldWithDefault(msg, 6, ""),
    membersList: jspb.Message.toObjectList(msg.getMembersList(),
    signaling_param_pb.TSigMemberInfo.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.himpb.SignalingInviteOfflineRelayNty}
 */
proto.himpb.SignalingInviteOfflineRelayNty.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.himpb.SignalingInviteOfflineRelayNty;
  return proto.himpb.SignalingInviteOfflineRelayNty.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.himpb.SignalingInviteOfflineRelayNty} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.himpb.SignalingInviteOfflineRelayNty}
 */
proto.himpb.SignalingInviteOfflineRelayNty.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new header_entity_pb.ReqBase;
      reader.readMessage(value,header_entity_pb.ReqBase.deserializeBinaryFromReader);
      msg.setBase(value);
      break;
    case 2:
      var value = new signaling_param_pb.TSigSessionInfo;
      reader.readMessage(value,signaling_param_pb.TSigSessionInfo.deserializeBinaryFromReader);
      msg.setInfo(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setInvitets(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestid(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setInviterid(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setCustominfo(value);
      break;
    case 7:
      var value = new signaling_param_pb.TSigMemberInfo;
      reader.readMessage(value,signaling_param_pb.TSigMemberInfo.deserializeBinaryFromReader);
      msg.addMembers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.himpb.SignalingInviteOfflineRelayNty.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.himpb.SignalingInviteOfflineRelayNty.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.himpb.SignalingInviteOfflineRelayNty} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.SignalingInviteOfflineRelayNty.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBase();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      header_entity_pb.ReqBase.serializeBinaryToWriter
    );
  }
  f = message.getInfo();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      signaling_param_pb.TSigSessionInfo.serializeBinaryToWriter
    );
  }
  f = message.getInvitets();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getRequestid();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getInviterid();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getCustominfo();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getMembersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      signaling_param_pb.TSigMemberInfo.serializeBinaryToWriter
    );
  }
};


/**
 * optional ReqBase base = 1;
 * @return {?proto.himpb.ReqBase}
 */
proto.himpb.SignalingInviteOfflineRelayNty.prototype.getBase = function() {
  return /** @type{?proto.himpb.ReqBase} */ (
    jspb.Message.getWrapperField(this, header_entity_pb.ReqBase, 1));
};


/**
 * @param {?proto.himpb.ReqBase|undefined} value
 * @return {!proto.himpb.SignalingInviteOfflineRelayNty} returns this
*/
proto.himpb.SignalingInviteOfflineRelayNty.prototype.setBase = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.himpb.SignalingInviteOfflineRelayNty} returns this
 */
proto.himpb.SignalingInviteOfflineRelayNty.prototype.clearBase = function() {
  return this.setBase(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.himpb.SignalingInviteOfflineRelayNty.prototype.hasBase = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional TSigSessionInfo info = 2;
 * @return {?proto.himpb.TSigSessionInfo}
 */
proto.himpb.SignalingInviteOfflineRelayNty.prototype.getInfo = function() {
  return /** @type{?proto.himpb.TSigSessionInfo} */ (
    jspb.Message.getWrapperField(this, signaling_param_pb.TSigSessionInfo, 2));
};


/**
 * @param {?proto.himpb.TSigSessionInfo|undefined} value
 * @return {!proto.himpb.SignalingInviteOfflineRelayNty} returns this
*/
proto.himpb.SignalingInviteOfflineRelayNty.prototype.setInfo = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.himpb.SignalingInviteOfflineRelayNty} returns this
 */
proto.himpb.SignalingInviteOfflineRelayNty.prototype.clearInfo = function() {
  return this.setInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.himpb.SignalingInviteOfflineRelayNty.prototype.hasInfo = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int64 inviteTs = 3;
 * @return {number}
 */
proto.himpb.SignalingInviteOfflineRelayNty.prototype.getInvitets = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.SignalingInviteOfflineRelayNty} returns this
 */
proto.himpb.SignalingInviteOfflineRelayNty.prototype.setInvitets = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string requestId = 4;
 * @return {string}
 */
proto.himpb.SignalingInviteOfflineRelayNty.prototype.getRequestid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.SignalingInviteOfflineRelayNty} returns this
 */
proto.himpb.SignalingInviteOfflineRelayNty.prototype.setRequestid = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string inviterId = 5;
 * @return {string}
 */
proto.himpb.SignalingInviteOfflineRelayNty.prototype.getInviterid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.SignalingInviteOfflineRelayNty} returns this
 */
proto.himpb.SignalingInviteOfflineRelayNty.prototype.setInviterid = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string customInfo = 6;
 * @return {string}
 */
proto.himpb.SignalingInviteOfflineRelayNty.prototype.getCustominfo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.SignalingInviteOfflineRelayNty} returns this
 */
proto.himpb.SignalingInviteOfflineRelayNty.prototype.setCustominfo = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * repeated TSigMemberInfo members = 7;
 * @return {!Array<!proto.himpb.TSigMemberInfo>}
 */
proto.himpb.SignalingInviteOfflineRelayNty.prototype.getMembersList = function() {
  return /** @type{!Array<!proto.himpb.TSigMemberInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, signaling_param_pb.TSigMemberInfo, 7));
};


/**
 * @param {!Array<!proto.himpb.TSigMemberInfo>} value
 * @return {!proto.himpb.SignalingInviteOfflineRelayNty} returns this
*/
proto.himpb.SignalingInviteOfflineRelayNty.prototype.setMembersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.himpb.TSigMemberInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.himpb.TSigMemberInfo}
 */
proto.himpb.SignalingInviteOfflineRelayNty.prototype.addMembers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.himpb.TSigMemberInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.himpb.SignalingInviteOfflineRelayNty} returns this
 */
proto.himpb.SignalingInviteOfflineRelayNty.prototype.clearMembersList = function() {
  return this.setMembersList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.himpb.SignalingInviteResultRcp.prototype.toObject = function(opt_includeInstance) {
  return proto.himpb.SignalingInviteResultRcp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.himpb.SignalingInviteResultRcp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.SignalingInviteResultRcp.toObject = function(includeInstance, msg) {
  var f, obj = {
    base: (f = msg.getBase()) && header_entity_pb.RspBase.toObject(includeInstance, f),
    roomid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    roomkey: jspb.Message.getFieldWithDefault(msg, 3, 0),
    inviteeuserid: jspb.Message.getFieldWithDefault(msg, 4, ""),
    inviterid: jspb.Message.getFieldWithDefault(msg, 5, ""),
    receipt: jspb.Message.getFieldWithDefault(msg, 6, 0),
    reason: jspb.Message.getFieldWithDefault(msg, 7, 0),
    custominfo: jspb.Message.getFieldWithDefault(msg, 8, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.himpb.SignalingInviteResultRcp}
 */
proto.himpb.SignalingInviteResultRcp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.himpb.SignalingInviteResultRcp;
  return proto.himpb.SignalingInviteResultRcp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.himpb.SignalingInviteResultRcp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.himpb.SignalingInviteResultRcp}
 */
proto.himpb.SignalingInviteResultRcp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new header_entity_pb.RspBase;
      reader.readMessage(value,header_entity_pb.RspBase.deserializeBinaryFromReader);
      msg.setBase(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRoomid(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setRoomkey(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setInviteeuserid(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setInviterid(value);
      break;
    case 6:
      var value = /** @type {!proto.himpb.ESig.InviteReceipt} */ (reader.readEnum());
      msg.setReceipt(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setReason(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setCustominfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.himpb.SignalingInviteResultRcp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.himpb.SignalingInviteResultRcp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.himpb.SignalingInviteResultRcp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.SignalingInviteResultRcp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBase();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      header_entity_pb.RspBase.serializeBinaryToWriter
    );
  }
  f = message.getRoomid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRoomkey();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getInviteeuserid();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getInviterid();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getReceipt();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getReason();
  if (f !== 0) {
    writer.writeUint32(
      7,
      f
    );
  }
  f = message.getCustominfo();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
};


/**
 * optional RspBase base = 1;
 * @return {?proto.himpb.RspBase}
 */
proto.himpb.SignalingInviteResultRcp.prototype.getBase = function() {
  return /** @type{?proto.himpb.RspBase} */ (
    jspb.Message.getWrapperField(this, header_entity_pb.RspBase, 1));
};


/**
 * @param {?proto.himpb.RspBase|undefined} value
 * @return {!proto.himpb.SignalingInviteResultRcp} returns this
*/
proto.himpb.SignalingInviteResultRcp.prototype.setBase = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.himpb.SignalingInviteResultRcp} returns this
 */
proto.himpb.SignalingInviteResultRcp.prototype.clearBase = function() {
  return this.setBase(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.himpb.SignalingInviteResultRcp.prototype.hasBase = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string roomId = 2;
 * @return {string}
 */
proto.himpb.SignalingInviteResultRcp.prototype.getRoomid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.SignalingInviteResultRcp} returns this
 */
proto.himpb.SignalingInviteResultRcp.prototype.setRoomid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint32 roomKey = 3;
 * @return {number}
 */
proto.himpb.SignalingInviteResultRcp.prototype.getRoomkey = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.SignalingInviteResultRcp} returns this
 */
proto.himpb.SignalingInviteResultRcp.prototype.setRoomkey = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string inviteeUserId = 4;
 * @return {string}
 */
proto.himpb.SignalingInviteResultRcp.prototype.getInviteeuserid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.SignalingInviteResultRcp} returns this
 */
proto.himpb.SignalingInviteResultRcp.prototype.setInviteeuserid = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string inviterId = 5;
 * @return {string}
 */
proto.himpb.SignalingInviteResultRcp.prototype.getInviterid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.SignalingInviteResultRcp} returns this
 */
proto.himpb.SignalingInviteResultRcp.prototype.setInviterid = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional ESig.InviteReceipt receipt = 6;
 * @return {!proto.himpb.ESig.InviteReceipt}
 */
proto.himpb.SignalingInviteResultRcp.prototype.getReceipt = function() {
  return /** @type {!proto.himpb.ESig.InviteReceipt} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.himpb.ESig.InviteReceipt} value
 * @return {!proto.himpb.SignalingInviteResultRcp} returns this
 */
proto.himpb.SignalingInviteResultRcp.prototype.setReceipt = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional uint32 reason = 7;
 * @return {number}
 */
proto.himpb.SignalingInviteResultRcp.prototype.getReason = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.SignalingInviteResultRcp} returns this
 */
proto.himpb.SignalingInviteResultRcp.prototype.setReason = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional string customInfo = 8;
 * @return {string}
 */
proto.himpb.SignalingInviteResultRcp.prototype.getCustominfo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.SignalingInviteResultRcp} returns this
 */
proto.himpb.SignalingInviteResultRcp.prototype.setCustominfo = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.himpb.SignalingJoinReq.prototype.toObject = function(opt_includeInstance) {
  return proto.himpb.SignalingJoinReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.himpb.SignalingJoinReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.SignalingJoinReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    base: (f = msg.getBase()) && header_entity_pb.ReqBase.toObject(includeInstance, f),
    roomid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    roomkey: jspb.Message.getFieldWithDefault(msg, 3, 0),
    source: jspb.Message.getFieldWithDefault(msg, 4, 0),
    srcid: jspb.Message.getFieldWithDefault(msg, 5, ""),
    custominfo: jspb.Message.getFieldWithDefault(msg, 6, ""),
    offlineenabled: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
    contact: (f = msg.getContact()) && header_entity_pb.TContactInfo.toObject(includeInstance, f),
    microphoneclose: jspb.Message.getBooleanFieldWithDefault(msg, 9, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.himpb.SignalingJoinReq}
 */
proto.himpb.SignalingJoinReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.himpb.SignalingJoinReq;
  return proto.himpb.SignalingJoinReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.himpb.SignalingJoinReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.himpb.SignalingJoinReq}
 */
proto.himpb.SignalingJoinReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new header_entity_pb.ReqBase;
      reader.readMessage(value,header_entity_pb.ReqBase.deserializeBinaryFromReader);
      msg.setBase(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRoomid(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setRoomkey(value);
      break;
    case 4:
      var value = /** @type {!proto.himpb.ESig.SourceType} */ (reader.readEnum());
      msg.setSource(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setSrcid(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setCustominfo(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setOfflineenabled(value);
      break;
    case 8:
      var value = new header_entity_pb.TContactInfo;
      reader.readMessage(value,header_entity_pb.TContactInfo.deserializeBinaryFromReader);
      msg.setContact(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMicrophoneclose(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.himpb.SignalingJoinReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.himpb.SignalingJoinReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.himpb.SignalingJoinReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.SignalingJoinReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBase();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      header_entity_pb.ReqBase.serializeBinaryToWriter
    );
  }
  f = message.getRoomid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRoomkey();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getSource();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getSrcid();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getCustominfo();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getOfflineenabled();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getContact();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      header_entity_pb.TContactInfo.serializeBinaryToWriter
    );
  }
  f = message.getMicrophoneclose();
  if (f) {
    writer.writeBool(
      9,
      f
    );
  }
};


/**
 * optional ReqBase base = 1;
 * @return {?proto.himpb.ReqBase}
 */
proto.himpb.SignalingJoinReq.prototype.getBase = function() {
  return /** @type{?proto.himpb.ReqBase} */ (
    jspb.Message.getWrapperField(this, header_entity_pb.ReqBase, 1));
};


/**
 * @param {?proto.himpb.ReqBase|undefined} value
 * @return {!proto.himpb.SignalingJoinReq} returns this
*/
proto.himpb.SignalingJoinReq.prototype.setBase = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.himpb.SignalingJoinReq} returns this
 */
proto.himpb.SignalingJoinReq.prototype.clearBase = function() {
  return this.setBase(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.himpb.SignalingJoinReq.prototype.hasBase = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string roomId = 2;
 * @return {string}
 */
proto.himpb.SignalingJoinReq.prototype.getRoomid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.SignalingJoinReq} returns this
 */
proto.himpb.SignalingJoinReq.prototype.setRoomid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint32 roomKey = 3;
 * @return {number}
 */
proto.himpb.SignalingJoinReq.prototype.getRoomkey = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.SignalingJoinReq} returns this
 */
proto.himpb.SignalingJoinReq.prototype.setRoomkey = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional ESig.SourceType source = 4;
 * @return {!proto.himpb.ESig.SourceType}
 */
proto.himpb.SignalingJoinReq.prototype.getSource = function() {
  return /** @type {!proto.himpb.ESig.SourceType} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.himpb.ESig.SourceType} value
 * @return {!proto.himpb.SignalingJoinReq} returns this
 */
proto.himpb.SignalingJoinReq.prototype.setSource = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional string srcId = 5;
 * @return {string}
 */
proto.himpb.SignalingJoinReq.prototype.getSrcid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.SignalingJoinReq} returns this
 */
proto.himpb.SignalingJoinReq.prototype.setSrcid = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string customInfo = 6;
 * @return {string}
 */
proto.himpb.SignalingJoinReq.prototype.getCustominfo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.SignalingJoinReq} returns this
 */
proto.himpb.SignalingJoinReq.prototype.setCustominfo = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional bool offlineEnabled = 7;
 * @return {boolean}
 */
proto.himpb.SignalingJoinReq.prototype.getOfflineenabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.himpb.SignalingJoinReq} returns this
 */
proto.himpb.SignalingJoinReq.prototype.setOfflineenabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * optional TContactInfo contact = 8;
 * @return {?proto.himpb.TContactInfo}
 */
proto.himpb.SignalingJoinReq.prototype.getContact = function() {
  return /** @type{?proto.himpb.TContactInfo} */ (
    jspb.Message.getWrapperField(this, header_entity_pb.TContactInfo, 8));
};


/**
 * @param {?proto.himpb.TContactInfo|undefined} value
 * @return {!proto.himpb.SignalingJoinReq} returns this
*/
proto.himpb.SignalingJoinReq.prototype.setContact = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.himpb.SignalingJoinReq} returns this
 */
proto.himpb.SignalingJoinReq.prototype.clearContact = function() {
  return this.setContact(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.himpb.SignalingJoinReq.prototype.hasContact = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional bool microphoneClose = 9;
 * @return {boolean}
 */
proto.himpb.SignalingJoinReq.prototype.getMicrophoneclose = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/**
 * @param {boolean} value
 * @return {!proto.himpb.SignalingJoinReq} returns this
 */
proto.himpb.SignalingJoinReq.prototype.setMicrophoneclose = function(value) {
  return jspb.Message.setProto3BooleanField(this, 9, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.himpb.SignalingJoinRsp.repeatedFields_ = [7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.himpb.SignalingJoinRsp.prototype.toObject = function(opt_includeInstance) {
  return proto.himpb.SignalingJoinRsp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.himpb.SignalingJoinRsp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.SignalingJoinRsp.toObject = function(includeInstance, msg) {
  var f, obj = {
    base: (f = msg.getBase()) && header_entity_pb.RspBase.toObject(includeInstance, f),
    roomid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    source: jspb.Message.getFieldWithDefault(msg, 3, 0),
    srcid: jspb.Message.getFieldWithDefault(msg, 4, ""),
    joints: jspb.Message.getFieldWithDefault(msg, 6, 0),
    info: (f = msg.getInfo()) && signaling_param_pb.TSigSessionInfo.toObject(includeInstance, f),
    membersList: jspb.Message.toObjectList(msg.getMembersList(),
    signaling_param_pb.TSigMemberInfo.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.himpb.SignalingJoinRsp}
 */
proto.himpb.SignalingJoinRsp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.himpb.SignalingJoinRsp;
  return proto.himpb.SignalingJoinRsp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.himpb.SignalingJoinRsp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.himpb.SignalingJoinRsp}
 */
proto.himpb.SignalingJoinRsp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new header_entity_pb.RspBase;
      reader.readMessage(value,header_entity_pb.RspBase.deserializeBinaryFromReader);
      msg.setBase(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRoomid(value);
      break;
    case 3:
      var value = /** @type {!proto.himpb.ESig.SourceType} */ (reader.readEnum());
      msg.setSource(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSrcid(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setJoints(value);
      break;
    case 5:
      var value = new signaling_param_pb.TSigSessionInfo;
      reader.readMessage(value,signaling_param_pb.TSigSessionInfo.deserializeBinaryFromReader);
      msg.setInfo(value);
      break;
    case 7:
      var value = new signaling_param_pb.TSigMemberInfo;
      reader.readMessage(value,signaling_param_pb.TSigMemberInfo.deserializeBinaryFromReader);
      msg.addMembers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.himpb.SignalingJoinRsp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.himpb.SignalingJoinRsp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.himpb.SignalingJoinRsp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.SignalingJoinRsp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBase();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      header_entity_pb.RspBase.serializeBinaryToWriter
    );
  }
  f = message.getRoomid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSource();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getSrcid();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getJoints();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getInfo();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      signaling_param_pb.TSigSessionInfo.serializeBinaryToWriter
    );
  }
  f = message.getMembersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      signaling_param_pb.TSigMemberInfo.serializeBinaryToWriter
    );
  }
};


/**
 * optional RspBase base = 1;
 * @return {?proto.himpb.RspBase}
 */
proto.himpb.SignalingJoinRsp.prototype.getBase = function() {
  return /** @type{?proto.himpb.RspBase} */ (
    jspb.Message.getWrapperField(this, header_entity_pb.RspBase, 1));
};


/**
 * @param {?proto.himpb.RspBase|undefined} value
 * @return {!proto.himpb.SignalingJoinRsp} returns this
*/
proto.himpb.SignalingJoinRsp.prototype.setBase = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.himpb.SignalingJoinRsp} returns this
 */
proto.himpb.SignalingJoinRsp.prototype.clearBase = function() {
  return this.setBase(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.himpb.SignalingJoinRsp.prototype.hasBase = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string roomId = 2;
 * @return {string}
 */
proto.himpb.SignalingJoinRsp.prototype.getRoomid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.SignalingJoinRsp} returns this
 */
proto.himpb.SignalingJoinRsp.prototype.setRoomid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional ESig.SourceType source = 3;
 * @return {!proto.himpb.ESig.SourceType}
 */
proto.himpb.SignalingJoinRsp.prototype.getSource = function() {
  return /** @type {!proto.himpb.ESig.SourceType} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.himpb.ESig.SourceType} value
 * @return {!proto.himpb.SignalingJoinRsp} returns this
 */
proto.himpb.SignalingJoinRsp.prototype.setSource = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional string srcId = 4;
 * @return {string}
 */
proto.himpb.SignalingJoinRsp.prototype.getSrcid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.SignalingJoinRsp} returns this
 */
proto.himpb.SignalingJoinRsp.prototype.setSrcid = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int64 joinTs = 6;
 * @return {number}
 */
proto.himpb.SignalingJoinRsp.prototype.getJoints = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.SignalingJoinRsp} returns this
 */
proto.himpb.SignalingJoinRsp.prototype.setJoints = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional TSigSessionInfo info = 5;
 * @return {?proto.himpb.TSigSessionInfo}
 */
proto.himpb.SignalingJoinRsp.prototype.getInfo = function() {
  return /** @type{?proto.himpb.TSigSessionInfo} */ (
    jspb.Message.getWrapperField(this, signaling_param_pb.TSigSessionInfo, 5));
};


/**
 * @param {?proto.himpb.TSigSessionInfo|undefined} value
 * @return {!proto.himpb.SignalingJoinRsp} returns this
*/
proto.himpb.SignalingJoinRsp.prototype.setInfo = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.himpb.SignalingJoinRsp} returns this
 */
proto.himpb.SignalingJoinRsp.prototype.clearInfo = function() {
  return this.setInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.himpb.SignalingJoinRsp.prototype.hasInfo = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * repeated TSigMemberInfo members = 7;
 * @return {!Array<!proto.himpb.TSigMemberInfo>}
 */
proto.himpb.SignalingJoinRsp.prototype.getMembersList = function() {
  return /** @type{!Array<!proto.himpb.TSigMemberInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, signaling_param_pb.TSigMemberInfo, 7));
};


/**
 * @param {!Array<!proto.himpb.TSigMemberInfo>} value
 * @return {!proto.himpb.SignalingJoinRsp} returns this
*/
proto.himpb.SignalingJoinRsp.prototype.setMembersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.himpb.TSigMemberInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.himpb.TSigMemberInfo}
 */
proto.himpb.SignalingJoinRsp.prototype.addMembers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.himpb.TSigMemberInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.himpb.SignalingJoinRsp} returns this
 */
proto.himpb.SignalingJoinRsp.prototype.clearMembersList = function() {
  return this.setMembersList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.himpb.SignalingKeepLiveReq.prototype.toObject = function(opt_includeInstance) {
  return proto.himpb.SignalingKeepLiveReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.himpb.SignalingKeepLiveReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.SignalingKeepLiveReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    base: (f = msg.getBase()) && header_entity_pb.ReqBase.toObject(includeInstance, f),
    roomid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    roomkey: jspb.Message.getFieldWithDefault(msg, 3, 0),
    custominfo: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.himpb.SignalingKeepLiveReq}
 */
proto.himpb.SignalingKeepLiveReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.himpb.SignalingKeepLiveReq;
  return proto.himpb.SignalingKeepLiveReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.himpb.SignalingKeepLiveReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.himpb.SignalingKeepLiveReq}
 */
proto.himpb.SignalingKeepLiveReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new header_entity_pb.ReqBase;
      reader.readMessage(value,header_entity_pb.ReqBase.deserializeBinaryFromReader);
      msg.setBase(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRoomid(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setRoomkey(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCustominfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.himpb.SignalingKeepLiveReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.himpb.SignalingKeepLiveReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.himpb.SignalingKeepLiveReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.SignalingKeepLiveReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBase();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      header_entity_pb.ReqBase.serializeBinaryToWriter
    );
  }
  f = message.getRoomid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRoomkey();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getCustominfo();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional ReqBase base = 1;
 * @return {?proto.himpb.ReqBase}
 */
proto.himpb.SignalingKeepLiveReq.prototype.getBase = function() {
  return /** @type{?proto.himpb.ReqBase} */ (
    jspb.Message.getWrapperField(this, header_entity_pb.ReqBase, 1));
};


/**
 * @param {?proto.himpb.ReqBase|undefined} value
 * @return {!proto.himpb.SignalingKeepLiveReq} returns this
*/
proto.himpb.SignalingKeepLiveReq.prototype.setBase = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.himpb.SignalingKeepLiveReq} returns this
 */
proto.himpb.SignalingKeepLiveReq.prototype.clearBase = function() {
  return this.setBase(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.himpb.SignalingKeepLiveReq.prototype.hasBase = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string roomId = 2;
 * @return {string}
 */
proto.himpb.SignalingKeepLiveReq.prototype.getRoomid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.SignalingKeepLiveReq} returns this
 */
proto.himpb.SignalingKeepLiveReq.prototype.setRoomid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint32 roomKey = 3;
 * @return {number}
 */
proto.himpb.SignalingKeepLiveReq.prototype.getRoomkey = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.SignalingKeepLiveReq} returns this
 */
proto.himpb.SignalingKeepLiveReq.prototype.setRoomkey = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string customInfo = 4;
 * @return {string}
 */
proto.himpb.SignalingKeepLiveReq.prototype.getCustominfo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.SignalingKeepLiveReq} returns this
 */
proto.himpb.SignalingKeepLiveReq.prototype.setCustominfo = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.himpb.SignalingKeepLiveRsp.prototype.toObject = function(opt_includeInstance) {
  return proto.himpb.SignalingKeepLiveRsp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.himpb.SignalingKeepLiveRsp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.SignalingKeepLiveRsp.toObject = function(includeInstance, msg) {
  var f, obj = {
    base: (f = msg.getBase()) && header_entity_pb.RspBase.toObject(includeInstance, f),
    roomid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    source: jspb.Message.getFieldWithDefault(msg, 3, 0),
    srcid: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.himpb.SignalingKeepLiveRsp}
 */
proto.himpb.SignalingKeepLiveRsp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.himpb.SignalingKeepLiveRsp;
  return proto.himpb.SignalingKeepLiveRsp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.himpb.SignalingKeepLiveRsp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.himpb.SignalingKeepLiveRsp}
 */
proto.himpb.SignalingKeepLiveRsp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new header_entity_pb.RspBase;
      reader.readMessage(value,header_entity_pb.RspBase.deserializeBinaryFromReader);
      msg.setBase(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRoomid(value);
      break;
    case 3:
      var value = /** @type {!proto.himpb.ESig.SourceType} */ (reader.readEnum());
      msg.setSource(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSrcid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.himpb.SignalingKeepLiveRsp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.himpb.SignalingKeepLiveRsp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.himpb.SignalingKeepLiveRsp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.SignalingKeepLiveRsp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBase();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      header_entity_pb.RspBase.serializeBinaryToWriter
    );
  }
  f = message.getRoomid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSource();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getSrcid();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional RspBase base = 1;
 * @return {?proto.himpb.RspBase}
 */
proto.himpb.SignalingKeepLiveRsp.prototype.getBase = function() {
  return /** @type{?proto.himpb.RspBase} */ (
    jspb.Message.getWrapperField(this, header_entity_pb.RspBase, 1));
};


/**
 * @param {?proto.himpb.RspBase|undefined} value
 * @return {!proto.himpb.SignalingKeepLiveRsp} returns this
*/
proto.himpb.SignalingKeepLiveRsp.prototype.setBase = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.himpb.SignalingKeepLiveRsp} returns this
 */
proto.himpb.SignalingKeepLiveRsp.prototype.clearBase = function() {
  return this.setBase(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.himpb.SignalingKeepLiveRsp.prototype.hasBase = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string roomId = 2;
 * @return {string}
 */
proto.himpb.SignalingKeepLiveRsp.prototype.getRoomid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.SignalingKeepLiveRsp} returns this
 */
proto.himpb.SignalingKeepLiveRsp.prototype.setRoomid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional ESig.SourceType source = 3;
 * @return {!proto.himpb.ESig.SourceType}
 */
proto.himpb.SignalingKeepLiveRsp.prototype.getSource = function() {
  return /** @type {!proto.himpb.ESig.SourceType} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.himpb.ESig.SourceType} value
 * @return {!proto.himpb.SignalingKeepLiveRsp} returns this
 */
proto.himpb.SignalingKeepLiveRsp.prototype.setSource = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional string srcId = 4;
 * @return {string}
 */
proto.himpb.SignalingKeepLiveRsp.prototype.getSrcid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.SignalingKeepLiveRsp} returns this
 */
proto.himpb.SignalingKeepLiveRsp.prototype.setSrcid = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.himpb.SignalingKeepLiveNty.prototype.toObject = function(opt_includeInstance) {
  return proto.himpb.SignalingKeepLiveNty.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.himpb.SignalingKeepLiveNty} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.SignalingKeepLiveNty.toObject = function(includeInstance, msg) {
  var f, obj = {
    base: (f = msg.getBase()) && header_entity_pb.RspBase.toObject(includeInstance, f),
    roomid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    source: jspb.Message.getFieldWithDefault(msg, 3, 0),
    srcid: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.himpb.SignalingKeepLiveNty}
 */
proto.himpb.SignalingKeepLiveNty.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.himpb.SignalingKeepLiveNty;
  return proto.himpb.SignalingKeepLiveNty.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.himpb.SignalingKeepLiveNty} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.himpb.SignalingKeepLiveNty}
 */
proto.himpb.SignalingKeepLiveNty.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new header_entity_pb.RspBase;
      reader.readMessage(value,header_entity_pb.RspBase.deserializeBinaryFromReader);
      msg.setBase(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRoomid(value);
      break;
    case 3:
      var value = /** @type {!proto.himpb.ESig.SourceType} */ (reader.readEnum());
      msg.setSource(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSrcid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.himpb.SignalingKeepLiveNty.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.himpb.SignalingKeepLiveNty.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.himpb.SignalingKeepLiveNty} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.SignalingKeepLiveNty.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBase();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      header_entity_pb.RspBase.serializeBinaryToWriter
    );
  }
  f = message.getRoomid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSource();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getSrcid();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional RspBase base = 1;
 * @return {?proto.himpb.RspBase}
 */
proto.himpb.SignalingKeepLiveNty.prototype.getBase = function() {
  return /** @type{?proto.himpb.RspBase} */ (
    jspb.Message.getWrapperField(this, header_entity_pb.RspBase, 1));
};


/**
 * @param {?proto.himpb.RspBase|undefined} value
 * @return {!proto.himpb.SignalingKeepLiveNty} returns this
*/
proto.himpb.SignalingKeepLiveNty.prototype.setBase = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.himpb.SignalingKeepLiveNty} returns this
 */
proto.himpb.SignalingKeepLiveNty.prototype.clearBase = function() {
  return this.setBase(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.himpb.SignalingKeepLiveNty.prototype.hasBase = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string roomId = 2;
 * @return {string}
 */
proto.himpb.SignalingKeepLiveNty.prototype.getRoomid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.SignalingKeepLiveNty} returns this
 */
proto.himpb.SignalingKeepLiveNty.prototype.setRoomid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional ESig.SourceType source = 3;
 * @return {!proto.himpb.ESig.SourceType}
 */
proto.himpb.SignalingKeepLiveNty.prototype.getSource = function() {
  return /** @type {!proto.himpb.ESig.SourceType} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.himpb.ESig.SourceType} value
 * @return {!proto.himpb.SignalingKeepLiveNty} returns this
 */
proto.himpb.SignalingKeepLiveNty.prototype.setSource = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional string srcId = 4;
 * @return {string}
 */
proto.himpb.SignalingKeepLiveNty.prototype.getSrcid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.SignalingKeepLiveNty} returns this
 */
proto.himpb.SignalingKeepLiveNty.prototype.setSrcid = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.himpb.SignalingUserCtrlNty.prototype.toObject = function(opt_includeInstance) {
  return proto.himpb.SignalingUserCtrlNty.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.himpb.SignalingUserCtrlNty} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.SignalingUserCtrlNty.toObject = function(includeInstance, msg) {
  var f, obj = {
    base: (f = msg.getBase()) && header_entity_pb.ReqBase.toObject(includeInstance, f),
    param: (f = msg.getParam()) && signaling_param_pb.SigSessionCtrlReqParam.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.himpb.SignalingUserCtrlNty}
 */
proto.himpb.SignalingUserCtrlNty.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.himpb.SignalingUserCtrlNty;
  return proto.himpb.SignalingUserCtrlNty.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.himpb.SignalingUserCtrlNty} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.himpb.SignalingUserCtrlNty}
 */
proto.himpb.SignalingUserCtrlNty.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new header_entity_pb.ReqBase;
      reader.readMessage(value,header_entity_pb.ReqBase.deserializeBinaryFromReader);
      msg.setBase(value);
      break;
    case 2:
      var value = new signaling_param_pb.SigSessionCtrlReqParam;
      reader.readMessage(value,signaling_param_pb.SigSessionCtrlReqParam.deserializeBinaryFromReader);
      msg.setParam(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.himpb.SignalingUserCtrlNty.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.himpb.SignalingUserCtrlNty.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.himpb.SignalingUserCtrlNty} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.SignalingUserCtrlNty.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBase();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      header_entity_pb.ReqBase.serializeBinaryToWriter
    );
  }
  f = message.getParam();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      signaling_param_pb.SigSessionCtrlReqParam.serializeBinaryToWriter
    );
  }
};


/**
 * optional ReqBase base = 1;
 * @return {?proto.himpb.ReqBase}
 */
proto.himpb.SignalingUserCtrlNty.prototype.getBase = function() {
  return /** @type{?proto.himpb.ReqBase} */ (
    jspb.Message.getWrapperField(this, header_entity_pb.ReqBase, 1));
};


/**
 * @param {?proto.himpb.ReqBase|undefined} value
 * @return {!proto.himpb.SignalingUserCtrlNty} returns this
*/
proto.himpb.SignalingUserCtrlNty.prototype.setBase = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.himpb.SignalingUserCtrlNty} returns this
 */
proto.himpb.SignalingUserCtrlNty.prototype.clearBase = function() {
  return this.setBase(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.himpb.SignalingUserCtrlNty.prototype.hasBase = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional SigSessionCtrlReqParam param = 2;
 * @return {?proto.himpb.SigSessionCtrlReqParam}
 */
proto.himpb.SignalingUserCtrlNty.prototype.getParam = function() {
  return /** @type{?proto.himpb.SigSessionCtrlReqParam} */ (
    jspb.Message.getWrapperField(this, signaling_param_pb.SigSessionCtrlReqParam, 2));
};


/**
 * @param {?proto.himpb.SigSessionCtrlReqParam|undefined} value
 * @return {!proto.himpb.SignalingUserCtrlNty} returns this
*/
proto.himpb.SignalingUserCtrlNty.prototype.setParam = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.himpb.SignalingUserCtrlNty} returns this
 */
proto.himpb.SignalingUserCtrlNty.prototype.clearParam = function() {
  return this.setParam(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.himpb.SignalingUserCtrlNty.prototype.hasParam = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.himpb.SignalingUserCtrlRcp.prototype.toObject = function(opt_includeInstance) {
  return proto.himpb.SignalingUserCtrlRcp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.himpb.SignalingUserCtrlRcp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.SignalingUserCtrlRcp.toObject = function(includeInstance, msg) {
  var f, obj = {
    base: (f = msg.getBase()) && header_entity_pb.RspBase.toObject(includeInstance, f),
    result: (f = msg.getResult()) && signaling_param_pb.SigSessionCtrlRcpParam.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.himpb.SignalingUserCtrlRcp}
 */
proto.himpb.SignalingUserCtrlRcp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.himpb.SignalingUserCtrlRcp;
  return proto.himpb.SignalingUserCtrlRcp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.himpb.SignalingUserCtrlRcp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.himpb.SignalingUserCtrlRcp}
 */
proto.himpb.SignalingUserCtrlRcp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new header_entity_pb.RspBase;
      reader.readMessage(value,header_entity_pb.RspBase.deserializeBinaryFromReader);
      msg.setBase(value);
      break;
    case 2:
      var value = new signaling_param_pb.SigSessionCtrlRcpParam;
      reader.readMessage(value,signaling_param_pb.SigSessionCtrlRcpParam.deserializeBinaryFromReader);
      msg.setResult(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.himpb.SignalingUserCtrlRcp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.himpb.SignalingUserCtrlRcp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.himpb.SignalingUserCtrlRcp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.SignalingUserCtrlRcp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBase();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      header_entity_pb.RspBase.serializeBinaryToWriter
    );
  }
  f = message.getResult();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      signaling_param_pb.SigSessionCtrlRcpParam.serializeBinaryToWriter
    );
  }
};


/**
 * optional RspBase base = 1;
 * @return {?proto.himpb.RspBase}
 */
proto.himpb.SignalingUserCtrlRcp.prototype.getBase = function() {
  return /** @type{?proto.himpb.RspBase} */ (
    jspb.Message.getWrapperField(this, header_entity_pb.RspBase, 1));
};


/**
 * @param {?proto.himpb.RspBase|undefined} value
 * @return {!proto.himpb.SignalingUserCtrlRcp} returns this
*/
proto.himpb.SignalingUserCtrlRcp.prototype.setBase = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.himpb.SignalingUserCtrlRcp} returns this
 */
proto.himpb.SignalingUserCtrlRcp.prototype.clearBase = function() {
  return this.setBase(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.himpb.SignalingUserCtrlRcp.prototype.hasBase = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional SigSessionCtrlRcpParam result = 2;
 * @return {?proto.himpb.SigSessionCtrlRcpParam}
 */
proto.himpb.SignalingUserCtrlRcp.prototype.getResult = function() {
  return /** @type{?proto.himpb.SigSessionCtrlRcpParam} */ (
    jspb.Message.getWrapperField(this, signaling_param_pb.SigSessionCtrlRcpParam, 2));
};


/**
 * @param {?proto.himpb.SigSessionCtrlRcpParam|undefined} value
 * @return {!proto.himpb.SignalingUserCtrlRcp} returns this
*/
proto.himpb.SignalingUserCtrlRcp.prototype.setResult = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.himpb.SignalingUserCtrlRcp} returns this
 */
proto.himpb.SignalingUserCtrlRcp.prototype.clearResult = function() {
  return this.setResult(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.himpb.SignalingUserCtrlRcp.prototype.hasResult = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.himpb.SignalingSessionStatusChangedNty.repeatedFields_ = [10,15];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.himpb.SignalingSessionStatusChangedNty.prototype.toObject = function(opt_includeInstance) {
  return proto.himpb.SignalingSessionStatusChangedNty.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.himpb.SignalingSessionStatusChangedNty} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.SignalingSessionStatusChangedNty.toObject = function(includeInstance, msg) {
  var f, obj = {
    base: (f = msg.getBase()) && header_entity_pb.ReqBase.toObject(includeInstance, f),
    roomid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    type: jspb.Message.getFieldWithDefault(msg, 3, 0),
    status: jspb.Message.getFieldWithDefault(msg, 4, 0),
    code: jspb.Message.getFieldWithDefault(msg, 5, 0),
    nowts: jspb.Message.getFieldWithDefault(msg, 6, 0),
    source: jspb.Message.getFieldWithDefault(msg, 7, 0),
    srcid: jspb.Message.getFieldWithDefault(msg, 8, ""),
    begints: jspb.Message.getFieldWithDefault(msg, 9, 0),
    relatedidsList: (f = jspb.Message.getRepeatedField(msg, 10)) == null ? undefined : f,
    custominfo: jspb.Message.getFieldWithDefault(msg, 11, ""),
    receiversList: (f = jspb.Message.getRepeatedField(msg, 15)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.himpb.SignalingSessionStatusChangedNty}
 */
proto.himpb.SignalingSessionStatusChangedNty.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.himpb.SignalingSessionStatusChangedNty;
  return proto.himpb.SignalingSessionStatusChangedNty.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.himpb.SignalingSessionStatusChangedNty} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.himpb.SignalingSessionStatusChangedNty}
 */
proto.himpb.SignalingSessionStatusChangedNty.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new header_entity_pb.ReqBase;
      reader.readMessage(value,header_entity_pb.ReqBase.deserializeBinaryFromReader);
      msg.setBase(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRoomid(value);
      break;
    case 3:
      var value = /** @type {!proto.himpb.ESig.SessionType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 4:
      var value = /** @type {!proto.himpb.ESig.SessionStatusType} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 5:
      var value = /** @type {!proto.himpb.ESig.SessionStatusCode} */ (reader.readEnum());
      msg.setCode(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setNowts(value);
      break;
    case 7:
      var value = /** @type {!proto.himpb.ESig.SourceType} */ (reader.readEnum());
      msg.setSource(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setSrcid(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setBegints(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.addRelatedids(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setCustominfo(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.addReceivers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.himpb.SignalingSessionStatusChangedNty.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.himpb.SignalingSessionStatusChangedNty.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.himpb.SignalingSessionStatusChangedNty} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.SignalingSessionStatusChangedNty.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBase();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      header_entity_pb.ReqBase.serializeBinaryToWriter
    );
  }
  f = message.getRoomid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getCode();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getNowts();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getSource();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = message.getSrcid();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getBegints();
  if (f !== 0) {
    writer.writeInt64(
      9,
      f
    );
  }
  f = message.getRelatedidsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      10,
      f
    );
  }
  f = message.getCustominfo();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getReceiversList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      15,
      f
    );
  }
};


/**
 * optional ReqBase base = 1;
 * @return {?proto.himpb.ReqBase}
 */
proto.himpb.SignalingSessionStatusChangedNty.prototype.getBase = function() {
  return /** @type{?proto.himpb.ReqBase} */ (
    jspb.Message.getWrapperField(this, header_entity_pb.ReqBase, 1));
};


/**
 * @param {?proto.himpb.ReqBase|undefined} value
 * @return {!proto.himpb.SignalingSessionStatusChangedNty} returns this
*/
proto.himpb.SignalingSessionStatusChangedNty.prototype.setBase = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.himpb.SignalingSessionStatusChangedNty} returns this
 */
proto.himpb.SignalingSessionStatusChangedNty.prototype.clearBase = function() {
  return this.setBase(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.himpb.SignalingSessionStatusChangedNty.prototype.hasBase = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string roomId = 2;
 * @return {string}
 */
proto.himpb.SignalingSessionStatusChangedNty.prototype.getRoomid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.SignalingSessionStatusChangedNty} returns this
 */
proto.himpb.SignalingSessionStatusChangedNty.prototype.setRoomid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional ESig.SessionType type = 3;
 * @return {!proto.himpb.ESig.SessionType}
 */
proto.himpb.SignalingSessionStatusChangedNty.prototype.getType = function() {
  return /** @type {!proto.himpb.ESig.SessionType} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.himpb.ESig.SessionType} value
 * @return {!proto.himpb.SignalingSessionStatusChangedNty} returns this
 */
proto.himpb.SignalingSessionStatusChangedNty.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional ESig.SessionStatusType status = 4;
 * @return {!proto.himpb.ESig.SessionStatusType}
 */
proto.himpb.SignalingSessionStatusChangedNty.prototype.getStatus = function() {
  return /** @type {!proto.himpb.ESig.SessionStatusType} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.himpb.ESig.SessionStatusType} value
 * @return {!proto.himpb.SignalingSessionStatusChangedNty} returns this
 */
proto.himpb.SignalingSessionStatusChangedNty.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional ESig.SessionStatusCode code = 5;
 * @return {!proto.himpb.ESig.SessionStatusCode}
 */
proto.himpb.SignalingSessionStatusChangedNty.prototype.getCode = function() {
  return /** @type {!proto.himpb.ESig.SessionStatusCode} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.himpb.ESig.SessionStatusCode} value
 * @return {!proto.himpb.SignalingSessionStatusChangedNty} returns this
 */
proto.himpb.SignalingSessionStatusChangedNty.prototype.setCode = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional int64 nowTs = 6;
 * @return {number}
 */
proto.himpb.SignalingSessionStatusChangedNty.prototype.getNowts = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.SignalingSessionStatusChangedNty} returns this
 */
proto.himpb.SignalingSessionStatusChangedNty.prototype.setNowts = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional ESig.SourceType source = 7;
 * @return {!proto.himpb.ESig.SourceType}
 */
proto.himpb.SignalingSessionStatusChangedNty.prototype.getSource = function() {
  return /** @type {!proto.himpb.ESig.SourceType} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.himpb.ESig.SourceType} value
 * @return {!proto.himpb.SignalingSessionStatusChangedNty} returns this
 */
proto.himpb.SignalingSessionStatusChangedNty.prototype.setSource = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};


/**
 * optional string srcId = 8;
 * @return {string}
 */
proto.himpb.SignalingSessionStatusChangedNty.prototype.getSrcid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.SignalingSessionStatusChangedNty} returns this
 */
proto.himpb.SignalingSessionStatusChangedNty.prototype.setSrcid = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional int64 beginTs = 9;
 * @return {number}
 */
proto.himpb.SignalingSessionStatusChangedNty.prototype.getBegints = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.SignalingSessionStatusChangedNty} returns this
 */
proto.himpb.SignalingSessionStatusChangedNty.prototype.setBegints = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * repeated string relatedIds = 10;
 * @return {!Array<string>}
 */
proto.himpb.SignalingSessionStatusChangedNty.prototype.getRelatedidsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 10));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.himpb.SignalingSessionStatusChangedNty} returns this
 */
proto.himpb.SignalingSessionStatusChangedNty.prototype.setRelatedidsList = function(value) {
  return jspb.Message.setField(this, 10, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.himpb.SignalingSessionStatusChangedNty} returns this
 */
proto.himpb.SignalingSessionStatusChangedNty.prototype.addRelatedids = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 10, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.himpb.SignalingSessionStatusChangedNty} returns this
 */
proto.himpb.SignalingSessionStatusChangedNty.prototype.clearRelatedidsList = function() {
  return this.setRelatedidsList([]);
};


/**
 * optional string customInfo = 11;
 * @return {string}
 */
proto.himpb.SignalingSessionStatusChangedNty.prototype.getCustominfo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.SignalingSessionStatusChangedNty} returns this
 */
proto.himpb.SignalingSessionStatusChangedNty.prototype.setCustominfo = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * repeated string receivers = 15;
 * @return {!Array<string>}
 */
proto.himpb.SignalingSessionStatusChangedNty.prototype.getReceiversList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 15));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.himpb.SignalingSessionStatusChangedNty} returns this
 */
proto.himpb.SignalingSessionStatusChangedNty.prototype.setReceiversList = function(value) {
  return jspb.Message.setField(this, 15, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.himpb.SignalingSessionStatusChangedNty} returns this
 */
proto.himpb.SignalingSessionStatusChangedNty.prototype.addReceivers = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 15, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.himpb.SignalingSessionStatusChangedNty} returns this
 */
proto.himpb.SignalingSessionStatusChangedNty.prototype.clearReceiversList = function() {
  return this.setReceiversList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.himpb.SignalingMemberStatusChangedNty.repeatedFields_ = [13,15,16];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.himpb.SignalingMemberStatusChangedNty.prototype.toObject = function(opt_includeInstance) {
  return proto.himpb.SignalingMemberStatusChangedNty.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.himpb.SignalingMemberStatusChangedNty} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.SignalingMemberStatusChangedNty.toObject = function(includeInstance, msg) {
  var f, obj = {
    base: (f = msg.getBase()) && header_entity_pb.ReqBase.toObject(includeInstance, f),
    roomid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    numofmembers: jspb.Message.getFieldWithDefault(msg, 3, 0),
    type: jspb.Message.getFieldWithDefault(msg, 4, 0),
    source: jspb.Message.getFieldWithDefault(msg, 5, 0),
    srcid: jspb.Message.getFieldWithDefault(msg, 6, ""),
    rolemask: jspb.Message.getFieldWithDefault(msg, 7, 0),
    memberid: jspb.Message.getFieldWithDefault(msg, 8, ""),
    reserveid: jspb.Message.getFieldWithDefault(msg, 9, ""),
    devicetype: jspb.Message.getFieldWithDefault(msg, 10, 0),
    status: jspb.Message.getFieldWithDefault(msg, 11, 0),
    nowts: jspb.Message.getFieldWithDefault(msg, 12, 0),
    controlsList: jspb.Message.toObjectList(msg.getControlsList(),
    signaling_param_pb.TSigSessionControl.toObject, includeInstance),
    custominfo: jspb.Message.getFieldWithDefault(msg, 14, ""),
    receiversList: (f = jspb.Message.getRepeatedField(msg, 15)) == null ? undefined : f,
    rolesList: (f = jspb.Message.getRepeatedField(msg, 16)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.himpb.SignalingMemberStatusChangedNty}
 */
proto.himpb.SignalingMemberStatusChangedNty.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.himpb.SignalingMemberStatusChangedNty;
  return proto.himpb.SignalingMemberStatusChangedNty.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.himpb.SignalingMemberStatusChangedNty} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.himpb.SignalingMemberStatusChangedNty}
 */
proto.himpb.SignalingMemberStatusChangedNty.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new header_entity_pb.ReqBase;
      reader.readMessage(value,header_entity_pb.ReqBase.deserializeBinaryFromReader);
      msg.setBase(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRoomid(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setNumofmembers(value);
      break;
    case 4:
      var value = /** @type {!proto.himpb.ESig.SessionType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 5:
      var value = /** @type {!proto.himpb.ESig.SourceType} */ (reader.readEnum());
      msg.setSource(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setSrcid(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setRolemask(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setMemberid(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setReserveid(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setDevicetype(value);
      break;
    case 11:
      var value = /** @type {!proto.himpb.ESig.MemberStatusType} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setNowts(value);
      break;
    case 13:
      var value = new signaling_param_pb.TSigSessionControl;
      reader.readMessage(value,signaling_param_pb.TSigSessionControl.deserializeBinaryFromReader);
      msg.addControls(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setCustominfo(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.addReceivers(value);
      break;
    case 16:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedUint32() : [reader.readUint32()]);
      for (var i = 0; i < values.length; i++) {
        msg.addRoles(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.himpb.SignalingMemberStatusChangedNty.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.himpb.SignalingMemberStatusChangedNty.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.himpb.SignalingMemberStatusChangedNty} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.SignalingMemberStatusChangedNty.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBase();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      header_entity_pb.ReqBase.serializeBinaryToWriter
    );
  }
  f = message.getRoomid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getNumofmembers();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getSource();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getSrcid();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getRolemask();
  if (f !== 0) {
    writer.writeUint32(
      7,
      f
    );
  }
  f = message.getMemberid();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getReserveid();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getDevicetype();
  if (f !== 0) {
    writer.writeUint32(
      10,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      11,
      f
    );
  }
  f = message.getNowts();
  if (f !== 0) {
    writer.writeInt64(
      12,
      f
    );
  }
  f = message.getControlsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      13,
      f,
      signaling_param_pb.TSigSessionControl.serializeBinaryToWriter
    );
  }
  f = message.getCustominfo();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getReceiversList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      15,
      f
    );
  }
  f = message.getRolesList();
  if (f.length > 0) {
    writer.writePackedUint32(
      16,
      f
    );
  }
};


/**
 * optional ReqBase base = 1;
 * @return {?proto.himpb.ReqBase}
 */
proto.himpb.SignalingMemberStatusChangedNty.prototype.getBase = function() {
  return /** @type{?proto.himpb.ReqBase} */ (
    jspb.Message.getWrapperField(this, header_entity_pb.ReqBase, 1));
};


/**
 * @param {?proto.himpb.ReqBase|undefined} value
 * @return {!proto.himpb.SignalingMemberStatusChangedNty} returns this
*/
proto.himpb.SignalingMemberStatusChangedNty.prototype.setBase = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.himpb.SignalingMemberStatusChangedNty} returns this
 */
proto.himpb.SignalingMemberStatusChangedNty.prototype.clearBase = function() {
  return this.setBase(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.himpb.SignalingMemberStatusChangedNty.prototype.hasBase = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string roomId = 2;
 * @return {string}
 */
proto.himpb.SignalingMemberStatusChangedNty.prototype.getRoomid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.SignalingMemberStatusChangedNty} returns this
 */
proto.himpb.SignalingMemberStatusChangedNty.prototype.setRoomid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint32 numOfMembers = 3;
 * @return {number}
 */
proto.himpb.SignalingMemberStatusChangedNty.prototype.getNumofmembers = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.SignalingMemberStatusChangedNty} returns this
 */
proto.himpb.SignalingMemberStatusChangedNty.prototype.setNumofmembers = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional ESig.SessionType type = 4;
 * @return {!proto.himpb.ESig.SessionType}
 */
proto.himpb.SignalingMemberStatusChangedNty.prototype.getType = function() {
  return /** @type {!proto.himpb.ESig.SessionType} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.himpb.ESig.SessionType} value
 * @return {!proto.himpb.SignalingMemberStatusChangedNty} returns this
 */
proto.himpb.SignalingMemberStatusChangedNty.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional ESig.SourceType source = 5;
 * @return {!proto.himpb.ESig.SourceType}
 */
proto.himpb.SignalingMemberStatusChangedNty.prototype.getSource = function() {
  return /** @type {!proto.himpb.ESig.SourceType} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.himpb.ESig.SourceType} value
 * @return {!proto.himpb.SignalingMemberStatusChangedNty} returns this
 */
proto.himpb.SignalingMemberStatusChangedNty.prototype.setSource = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional string srcId = 6;
 * @return {string}
 */
proto.himpb.SignalingMemberStatusChangedNty.prototype.getSrcid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.SignalingMemberStatusChangedNty} returns this
 */
proto.himpb.SignalingMemberStatusChangedNty.prototype.setSrcid = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional uint32 roleMask = 7;
 * @return {number}
 */
proto.himpb.SignalingMemberStatusChangedNty.prototype.getRolemask = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.SignalingMemberStatusChangedNty} returns this
 */
proto.himpb.SignalingMemberStatusChangedNty.prototype.setRolemask = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional string memberId = 8;
 * @return {string}
 */
proto.himpb.SignalingMemberStatusChangedNty.prototype.getMemberid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.SignalingMemberStatusChangedNty} returns this
 */
proto.himpb.SignalingMemberStatusChangedNty.prototype.setMemberid = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string reserveId = 9;
 * @return {string}
 */
proto.himpb.SignalingMemberStatusChangedNty.prototype.getReserveid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.SignalingMemberStatusChangedNty} returns this
 */
proto.himpb.SignalingMemberStatusChangedNty.prototype.setReserveid = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional uint32 deviceType = 10;
 * @return {number}
 */
proto.himpb.SignalingMemberStatusChangedNty.prototype.getDevicetype = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.SignalingMemberStatusChangedNty} returns this
 */
proto.himpb.SignalingMemberStatusChangedNty.prototype.setDevicetype = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional ESig.MemberStatusType status = 11;
 * @return {!proto.himpb.ESig.MemberStatusType}
 */
proto.himpb.SignalingMemberStatusChangedNty.prototype.getStatus = function() {
  return /** @type {!proto.himpb.ESig.MemberStatusType} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {!proto.himpb.ESig.MemberStatusType} value
 * @return {!proto.himpb.SignalingMemberStatusChangedNty} returns this
 */
proto.himpb.SignalingMemberStatusChangedNty.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 11, value);
};


/**
 * optional int64 nowTs = 12;
 * @return {number}
 */
proto.himpb.SignalingMemberStatusChangedNty.prototype.getNowts = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.SignalingMemberStatusChangedNty} returns this
 */
proto.himpb.SignalingMemberStatusChangedNty.prototype.setNowts = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * repeated TSigSessionControl controls = 13;
 * @return {!Array<!proto.himpb.TSigSessionControl>}
 */
proto.himpb.SignalingMemberStatusChangedNty.prototype.getControlsList = function() {
  return /** @type{!Array<!proto.himpb.TSigSessionControl>} */ (
    jspb.Message.getRepeatedWrapperField(this, signaling_param_pb.TSigSessionControl, 13));
};


/**
 * @param {!Array<!proto.himpb.TSigSessionControl>} value
 * @return {!proto.himpb.SignalingMemberStatusChangedNty} returns this
*/
proto.himpb.SignalingMemberStatusChangedNty.prototype.setControlsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 13, value);
};


/**
 * @param {!proto.himpb.TSigSessionControl=} opt_value
 * @param {number=} opt_index
 * @return {!proto.himpb.TSigSessionControl}
 */
proto.himpb.SignalingMemberStatusChangedNty.prototype.addControls = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 13, opt_value, proto.himpb.TSigSessionControl, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.himpb.SignalingMemberStatusChangedNty} returns this
 */
proto.himpb.SignalingMemberStatusChangedNty.prototype.clearControlsList = function() {
  return this.setControlsList([]);
};


/**
 * optional string customInfo = 14;
 * @return {string}
 */
proto.himpb.SignalingMemberStatusChangedNty.prototype.getCustominfo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.SignalingMemberStatusChangedNty} returns this
 */
proto.himpb.SignalingMemberStatusChangedNty.prototype.setCustominfo = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * repeated string receivers = 15;
 * @return {!Array<string>}
 */
proto.himpb.SignalingMemberStatusChangedNty.prototype.getReceiversList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 15));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.himpb.SignalingMemberStatusChangedNty} returns this
 */
proto.himpb.SignalingMemberStatusChangedNty.prototype.setReceiversList = function(value) {
  return jspb.Message.setField(this, 15, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.himpb.SignalingMemberStatusChangedNty} returns this
 */
proto.himpb.SignalingMemberStatusChangedNty.prototype.addReceivers = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 15, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.himpb.SignalingMemberStatusChangedNty} returns this
 */
proto.himpb.SignalingMemberStatusChangedNty.prototype.clearReceiversList = function() {
  return this.setReceiversList([]);
};


/**
 * repeated uint32 roles = 16;
 * @return {!Array<number>}
 */
proto.himpb.SignalingMemberStatusChangedNty.prototype.getRolesList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 16));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.himpb.SignalingMemberStatusChangedNty} returns this
 */
proto.himpb.SignalingMemberStatusChangedNty.prototype.setRolesList = function(value) {
  return jspb.Message.setField(this, 16, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.himpb.SignalingMemberStatusChangedNty} returns this
 */
proto.himpb.SignalingMemberStatusChangedNty.prototype.addRoles = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 16, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.himpb.SignalingMemberStatusChangedNty} returns this
 */
proto.himpb.SignalingMemberStatusChangedNty.prototype.clearRolesList = function() {
  return this.setRolesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.himpb.SignalingMemberStatusChangedBatchNty.repeatedFields_ = [7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.himpb.SignalingMemberStatusChangedBatchNty.prototype.toObject = function(opt_includeInstance) {
  return proto.himpb.SignalingMemberStatusChangedBatchNty.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.himpb.SignalingMemberStatusChangedBatchNty} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.SignalingMemberStatusChangedBatchNty.toObject = function(includeInstance, msg) {
  var f, obj = {
    base: (f = msg.getBase()) && header_entity_pb.ReqBase.toObject(includeInstance, f),
    roomid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    numofmembers: jspb.Message.getFieldWithDefault(msg, 3, 0),
    type: jspb.Message.getFieldWithDefault(msg, 4, 0),
    source: jspb.Message.getFieldWithDefault(msg, 5, 0),
    srcid: jspb.Message.getFieldWithDefault(msg, 6, ""),
    changedmembersList: jspb.Message.toObjectList(msg.getChangedmembersList(),
    proto.himpb.SigMemberStatus.toObject, includeInstance),
    custominfo: jspb.Message.getFieldWithDefault(msg, 15, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.himpb.SignalingMemberStatusChangedBatchNty}
 */
proto.himpb.SignalingMemberStatusChangedBatchNty.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.himpb.SignalingMemberStatusChangedBatchNty;
  return proto.himpb.SignalingMemberStatusChangedBatchNty.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.himpb.SignalingMemberStatusChangedBatchNty} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.himpb.SignalingMemberStatusChangedBatchNty}
 */
proto.himpb.SignalingMemberStatusChangedBatchNty.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new header_entity_pb.ReqBase;
      reader.readMessage(value,header_entity_pb.ReqBase.deserializeBinaryFromReader);
      msg.setBase(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRoomid(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setNumofmembers(value);
      break;
    case 4:
      var value = /** @type {!proto.himpb.ESig.SessionType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 5:
      var value = /** @type {!proto.himpb.ESig.SourceType} */ (reader.readEnum());
      msg.setSource(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setSrcid(value);
      break;
    case 7:
      var value = new proto.himpb.SigMemberStatus;
      reader.readMessage(value,proto.himpb.SigMemberStatus.deserializeBinaryFromReader);
      msg.addChangedmembers(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setCustominfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.himpb.SignalingMemberStatusChangedBatchNty.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.himpb.SignalingMemberStatusChangedBatchNty.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.himpb.SignalingMemberStatusChangedBatchNty} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.SignalingMemberStatusChangedBatchNty.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBase();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      header_entity_pb.ReqBase.serializeBinaryToWriter
    );
  }
  f = message.getRoomid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getNumofmembers();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getSource();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getSrcid();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getChangedmembersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      proto.himpb.SigMemberStatus.serializeBinaryToWriter
    );
  }
  f = message.getCustominfo();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
};


/**
 * optional ReqBase base = 1;
 * @return {?proto.himpb.ReqBase}
 */
proto.himpb.SignalingMemberStatusChangedBatchNty.prototype.getBase = function() {
  return /** @type{?proto.himpb.ReqBase} */ (
    jspb.Message.getWrapperField(this, header_entity_pb.ReqBase, 1));
};


/**
 * @param {?proto.himpb.ReqBase|undefined} value
 * @return {!proto.himpb.SignalingMemberStatusChangedBatchNty} returns this
*/
proto.himpb.SignalingMemberStatusChangedBatchNty.prototype.setBase = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.himpb.SignalingMemberStatusChangedBatchNty} returns this
 */
proto.himpb.SignalingMemberStatusChangedBatchNty.prototype.clearBase = function() {
  return this.setBase(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.himpb.SignalingMemberStatusChangedBatchNty.prototype.hasBase = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string roomId = 2;
 * @return {string}
 */
proto.himpb.SignalingMemberStatusChangedBatchNty.prototype.getRoomid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.SignalingMemberStatusChangedBatchNty} returns this
 */
proto.himpb.SignalingMemberStatusChangedBatchNty.prototype.setRoomid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint32 numOfMembers = 3;
 * @return {number}
 */
proto.himpb.SignalingMemberStatusChangedBatchNty.prototype.getNumofmembers = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.SignalingMemberStatusChangedBatchNty} returns this
 */
proto.himpb.SignalingMemberStatusChangedBatchNty.prototype.setNumofmembers = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional ESig.SessionType type = 4;
 * @return {!proto.himpb.ESig.SessionType}
 */
proto.himpb.SignalingMemberStatusChangedBatchNty.prototype.getType = function() {
  return /** @type {!proto.himpb.ESig.SessionType} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.himpb.ESig.SessionType} value
 * @return {!proto.himpb.SignalingMemberStatusChangedBatchNty} returns this
 */
proto.himpb.SignalingMemberStatusChangedBatchNty.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional ESig.SourceType source = 5;
 * @return {!proto.himpb.ESig.SourceType}
 */
proto.himpb.SignalingMemberStatusChangedBatchNty.prototype.getSource = function() {
  return /** @type {!proto.himpb.ESig.SourceType} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.himpb.ESig.SourceType} value
 * @return {!proto.himpb.SignalingMemberStatusChangedBatchNty} returns this
 */
proto.himpb.SignalingMemberStatusChangedBatchNty.prototype.setSource = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional string srcId = 6;
 * @return {string}
 */
proto.himpb.SignalingMemberStatusChangedBatchNty.prototype.getSrcid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.SignalingMemberStatusChangedBatchNty} returns this
 */
proto.himpb.SignalingMemberStatusChangedBatchNty.prototype.setSrcid = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * repeated SigMemberStatus changedMembers = 7;
 * @return {!Array<!proto.himpb.SigMemberStatus>}
 */
proto.himpb.SignalingMemberStatusChangedBatchNty.prototype.getChangedmembersList = function() {
  return /** @type{!Array<!proto.himpb.SigMemberStatus>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.himpb.SigMemberStatus, 7));
};


/**
 * @param {!Array<!proto.himpb.SigMemberStatus>} value
 * @return {!proto.himpb.SignalingMemberStatusChangedBatchNty} returns this
*/
proto.himpb.SignalingMemberStatusChangedBatchNty.prototype.setChangedmembersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.himpb.SigMemberStatus=} opt_value
 * @param {number=} opt_index
 * @return {!proto.himpb.SigMemberStatus}
 */
proto.himpb.SignalingMemberStatusChangedBatchNty.prototype.addChangedmembers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.himpb.SigMemberStatus, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.himpb.SignalingMemberStatusChangedBatchNty} returns this
 */
proto.himpb.SignalingMemberStatusChangedBatchNty.prototype.clearChangedmembersList = function() {
  return this.setChangedmembersList([]);
};


/**
 * optional string customInfo = 15;
 * @return {string}
 */
proto.himpb.SignalingMemberStatusChangedBatchNty.prototype.getCustominfo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.SignalingMemberStatusChangedBatchNty} returns this
 */
proto.himpb.SignalingMemberStatusChangedBatchNty.prototype.setCustominfo = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.himpb.SigMemberStatus.repeatedFields_ = [5,8];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.himpb.SigMemberStatus.prototype.toObject = function(opt_includeInstance) {
  return proto.himpb.SigMemberStatus.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.himpb.SigMemberStatus} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.SigMemberStatus.toObject = function(includeInstance, msg) {
  var f, obj = {
    rolemask: jspb.Message.getFieldWithDefault(msg, 1, 0),
    memberid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    devicetype: jspb.Message.getFieldWithDefault(msg, 3, 0),
    status: jspb.Message.getFieldWithDefault(msg, 4, 0),
    controlsList: jspb.Message.toObjectList(msg.getControlsList(),
    signaling_param_pb.TSigSessionControl.toObject, includeInstance),
    nowts: jspb.Message.getFieldWithDefault(msg, 7, 0),
    rolesList: (f = jspb.Message.getRepeatedField(msg, 8)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.himpb.SigMemberStatus}
 */
proto.himpb.SigMemberStatus.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.himpb.SigMemberStatus;
  return proto.himpb.SigMemberStatus.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.himpb.SigMemberStatus} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.himpb.SigMemberStatus}
 */
proto.himpb.SigMemberStatus.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setRolemask(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMemberid(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setDevicetype(value);
      break;
    case 4:
      var value = /** @type {!proto.himpb.ESig.MemberStatusType} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 5:
      var value = new signaling_param_pb.TSigSessionControl;
      reader.readMessage(value,signaling_param_pb.TSigSessionControl.deserializeBinaryFromReader);
      msg.addControls(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setNowts(value);
      break;
    case 8:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedUint32() : [reader.readUint32()]);
      for (var i = 0; i < values.length; i++) {
        msg.addRoles(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.himpb.SigMemberStatus.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.himpb.SigMemberStatus.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.himpb.SigMemberStatus} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.SigMemberStatus.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRolemask();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getMemberid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDevicetype();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getControlsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      signaling_param_pb.TSigSessionControl.serializeBinaryToWriter
    );
  }
  f = message.getNowts();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getRolesList();
  if (f.length > 0) {
    writer.writePackedUint32(
      8,
      f
    );
  }
};


/**
 * optional uint32 roleMask = 1;
 * @return {number}
 */
proto.himpb.SigMemberStatus.prototype.getRolemask = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.SigMemberStatus} returns this
 */
proto.himpb.SigMemberStatus.prototype.setRolemask = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string memberId = 2;
 * @return {string}
 */
proto.himpb.SigMemberStatus.prototype.getMemberid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.SigMemberStatus} returns this
 */
proto.himpb.SigMemberStatus.prototype.setMemberid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint32 deviceType = 3;
 * @return {number}
 */
proto.himpb.SigMemberStatus.prototype.getDevicetype = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.SigMemberStatus} returns this
 */
proto.himpb.SigMemberStatus.prototype.setDevicetype = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional ESig.MemberStatusType status = 4;
 * @return {!proto.himpb.ESig.MemberStatusType}
 */
proto.himpb.SigMemberStatus.prototype.getStatus = function() {
  return /** @type {!proto.himpb.ESig.MemberStatusType} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.himpb.ESig.MemberStatusType} value
 * @return {!proto.himpb.SigMemberStatus} returns this
 */
proto.himpb.SigMemberStatus.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * repeated TSigSessionControl controls = 5;
 * @return {!Array<!proto.himpb.TSigSessionControl>}
 */
proto.himpb.SigMemberStatus.prototype.getControlsList = function() {
  return /** @type{!Array<!proto.himpb.TSigSessionControl>} */ (
    jspb.Message.getRepeatedWrapperField(this, signaling_param_pb.TSigSessionControl, 5));
};


/**
 * @param {!Array<!proto.himpb.TSigSessionControl>} value
 * @return {!proto.himpb.SigMemberStatus} returns this
*/
proto.himpb.SigMemberStatus.prototype.setControlsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.himpb.TSigSessionControl=} opt_value
 * @param {number=} opt_index
 * @return {!proto.himpb.TSigSessionControl}
 */
proto.himpb.SigMemberStatus.prototype.addControls = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.himpb.TSigSessionControl, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.himpb.SigMemberStatus} returns this
 */
proto.himpb.SigMemberStatus.prototype.clearControlsList = function() {
  return this.setControlsList([]);
};


/**
 * optional int64 nowTs = 7;
 * @return {number}
 */
proto.himpb.SigMemberStatus.prototype.getNowts = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.SigMemberStatus} returns this
 */
proto.himpb.SigMemberStatus.prototype.setNowts = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * repeated uint32 roles = 8;
 * @return {!Array<number>}
 */
proto.himpb.SigMemberStatus.prototype.getRolesList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 8));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.himpb.SigMemberStatus} returns this
 */
proto.himpb.SigMemberStatus.prototype.setRolesList = function(value) {
  return jspb.Message.setField(this, 8, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.himpb.SigMemberStatus} returns this
 */
proto.himpb.SigMemberStatus.prototype.addRoles = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 8, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.himpb.SigMemberStatus} returns this
 */
proto.himpb.SigMemberStatus.prototype.clearRolesList = function() {
  return this.setRolesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.himpb.SignalingQueryReq.prototype.toObject = function(opt_includeInstance) {
  return proto.himpb.SignalingQueryReq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.himpb.SignalingQueryReq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.SignalingQueryReq.toObject = function(includeInstance, msg) {
  var f, obj = {
    base: (f = msg.getBase()) && header_entity_pb.ReqBase.toObject(includeInstance, f),
    roomid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    roomkey: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.himpb.SignalingQueryReq}
 */
proto.himpb.SignalingQueryReq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.himpb.SignalingQueryReq;
  return proto.himpb.SignalingQueryReq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.himpb.SignalingQueryReq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.himpb.SignalingQueryReq}
 */
proto.himpb.SignalingQueryReq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new header_entity_pb.ReqBase;
      reader.readMessage(value,header_entity_pb.ReqBase.deserializeBinaryFromReader);
      msg.setBase(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRoomid(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setRoomkey(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.himpb.SignalingQueryReq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.himpb.SignalingQueryReq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.himpb.SignalingQueryReq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.SignalingQueryReq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBase();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      header_entity_pb.ReqBase.serializeBinaryToWriter
    );
  }
  f = message.getRoomid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRoomkey();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
};


/**
 * optional ReqBase base = 1;
 * @return {?proto.himpb.ReqBase}
 */
proto.himpb.SignalingQueryReq.prototype.getBase = function() {
  return /** @type{?proto.himpb.ReqBase} */ (
    jspb.Message.getWrapperField(this, header_entity_pb.ReqBase, 1));
};


/**
 * @param {?proto.himpb.ReqBase|undefined} value
 * @return {!proto.himpb.SignalingQueryReq} returns this
*/
proto.himpb.SignalingQueryReq.prototype.setBase = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.himpb.SignalingQueryReq} returns this
 */
proto.himpb.SignalingQueryReq.prototype.clearBase = function() {
  return this.setBase(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.himpb.SignalingQueryReq.prototype.hasBase = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string roomId = 2;
 * @return {string}
 */
proto.himpb.SignalingQueryReq.prototype.getRoomid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.SignalingQueryReq} returns this
 */
proto.himpb.SignalingQueryReq.prototype.setRoomid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint32 roomKey = 3;
 * @return {number}
 */
proto.himpb.SignalingQueryReq.prototype.getRoomkey = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.himpb.SignalingQueryReq} returns this
 */
proto.himpb.SignalingQueryReq.prototype.setRoomkey = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.himpb.SignalingQueryRsp.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.himpb.SignalingQueryRsp.prototype.toObject = function(opt_includeInstance) {
  return proto.himpb.SignalingQueryRsp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.himpb.SignalingQueryRsp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.SignalingQueryRsp.toObject = function(includeInstance, msg) {
  var f, obj = {
    base: (f = msg.getBase()) && header_entity_pb.RspBase.toObject(includeInstance, f),
    roomid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    info: (f = msg.getInfo()) && signaling_param_pb.TSigSessionInfo.toObject(includeInstance, f),
    membersList: jspb.Message.toObjectList(msg.getMembersList(),
    signaling_param_pb.TSigMemberInfo.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.himpb.SignalingQueryRsp}
 */
proto.himpb.SignalingQueryRsp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.himpb.SignalingQueryRsp;
  return proto.himpb.SignalingQueryRsp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.himpb.SignalingQueryRsp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.himpb.SignalingQueryRsp}
 */
proto.himpb.SignalingQueryRsp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new header_entity_pb.RspBase;
      reader.readMessage(value,header_entity_pb.RspBase.deserializeBinaryFromReader);
      msg.setBase(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRoomid(value);
      break;
    case 3:
      var value = new signaling_param_pb.TSigSessionInfo;
      reader.readMessage(value,signaling_param_pb.TSigSessionInfo.deserializeBinaryFromReader);
      msg.setInfo(value);
      break;
    case 4:
      var value = new signaling_param_pb.TSigMemberInfo;
      reader.readMessage(value,signaling_param_pb.TSigMemberInfo.deserializeBinaryFromReader);
      msg.addMembers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.himpb.SignalingQueryRsp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.himpb.SignalingQueryRsp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.himpb.SignalingQueryRsp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.himpb.SignalingQueryRsp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBase();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      header_entity_pb.RspBase.serializeBinaryToWriter
    );
  }
  f = message.getRoomid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getInfo();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      signaling_param_pb.TSigSessionInfo.serializeBinaryToWriter
    );
  }
  f = message.getMembersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      signaling_param_pb.TSigMemberInfo.serializeBinaryToWriter
    );
  }
};


/**
 * optional RspBase base = 1;
 * @return {?proto.himpb.RspBase}
 */
proto.himpb.SignalingQueryRsp.prototype.getBase = function() {
  return /** @type{?proto.himpb.RspBase} */ (
    jspb.Message.getWrapperField(this, header_entity_pb.RspBase, 1));
};


/**
 * @param {?proto.himpb.RspBase|undefined} value
 * @return {!proto.himpb.SignalingQueryRsp} returns this
*/
proto.himpb.SignalingQueryRsp.prototype.setBase = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.himpb.SignalingQueryRsp} returns this
 */
proto.himpb.SignalingQueryRsp.prototype.clearBase = function() {
  return this.setBase(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.himpb.SignalingQueryRsp.prototype.hasBase = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string roomId = 2;
 * @return {string}
 */
proto.himpb.SignalingQueryRsp.prototype.getRoomid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.himpb.SignalingQueryRsp} returns this
 */
proto.himpb.SignalingQueryRsp.prototype.setRoomid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional TSigSessionInfo info = 3;
 * @return {?proto.himpb.TSigSessionInfo}
 */
proto.himpb.SignalingQueryRsp.prototype.getInfo = function() {
  return /** @type{?proto.himpb.TSigSessionInfo} */ (
    jspb.Message.getWrapperField(this, signaling_param_pb.TSigSessionInfo, 3));
};


/**
 * @param {?proto.himpb.TSigSessionInfo|undefined} value
 * @return {!proto.himpb.SignalingQueryRsp} returns this
*/
proto.himpb.SignalingQueryRsp.prototype.setInfo = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.himpb.SignalingQueryRsp} returns this
 */
proto.himpb.SignalingQueryRsp.prototype.clearInfo = function() {
  return this.setInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.himpb.SignalingQueryRsp.prototype.hasInfo = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * repeated TSigMemberInfo members = 4;
 * @return {!Array<!proto.himpb.TSigMemberInfo>}
 */
proto.himpb.SignalingQueryRsp.prototype.getMembersList = function() {
  return /** @type{!Array<!proto.himpb.TSigMemberInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, signaling_param_pb.TSigMemberInfo, 4));
};


/**
 * @param {!Array<!proto.himpb.TSigMemberInfo>} value
 * @return {!proto.himpb.SignalingQueryRsp} returns this
*/
proto.himpb.SignalingQueryRsp.prototype.setMembersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.himpb.TSigMemberInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.himpb.TSigMemberInfo}
 */
proto.himpb.SignalingQueryRsp.prototype.addMembers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.himpb.TSigMemberInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.himpb.SignalingQueryRsp} returns this
 */
proto.himpb.SignalingQueryRsp.prototype.clearMembersList = function() {
  return this.setMembersList([]);
};


goog.object.extend(exports, proto.himpb);
